import { useNavigate, useParams } from "react-router-dom";
import CreateAsset from "./CreateAsset";
import { useEffect, useState } from "react";
import SuccessBee from "../../../../assets/images/SuccessBee.svg";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import { useDispatch, useSelector } from "react-redux";
import { getAllDropdownBySubTypeId, getAssetTypeOptions, getCatalogItemByAssetModelId, getCategory2BasedOnCategory, getCategoryTypeBasedOnCategory, getEquipmentModelsBasedOnMake, getModelsBasedOnMake, saveCatalogItem, setAllDropdownBySubTypeId, setCatalogItemByAssetModelId, setIsCatalogItemSaved, setIsSelectedVehicleLevelValid } from "Store/Component/CatalogManagement/CatalogManagementAction";
import { addFilterGetData, commononUploadClick, CONSTRUCTION_EQUIPMENT_CATEGORY_WITH_CATEGORY_2, formatPrice, getFileName, popupInitialData, SNOW_CATEGORY_WITH_CATGORY_TYPE, STANDARDIZED_EQUIPMENT_CATEGORY_WITH_CATEGORY_2 } from "utils";
import UploadAttachmentsDispatch from "Store/AssetManagement/UploadAttachments/UploadAttachmentsDispatch";
import { v1 as uuid } from "uuid";
import { getAssetType } from "Store/AssetManagement/AssetType/AssetTypeAction";
import userProfileSelectors from '../../../../../redux/UserProfile/selectors'
import { getOnlyNumbers } from "client/utils/RequisitionUtil";
import {uploadAttachments} from 'Store/AssetManagement/UploadAttachments/UploadAttachmentsAction'
import {
  vehicleValuesKey,
  assetModelAttributes,
  kitValuesKey,
  vehicleRequiredFields,
  mowerRequiredFields,
  snowRequiredFields,
  trailerRequiredField,
  utilityVehicleRequiredField,
  standardizedEquipmentRequiredFields,
  constructionEquipmentRequiredFields
} from "./CreateAsset-Helper";
import { AttributeName, CONSTANTS } from "client/utils/constants";
import { getCatalogUpdateMake, setCatalogRemoveCapacity, setCatalogRemoveDriveTrain, setCatalogRemoveEqClassCode, setCatalogRemoveMake, setCatalogRemoveNoOfDoor, setCatalogRemovePowerType, setCatalogRemoveUpfit, setCatalogRemoveVehicleLevel, setCatalogRemoveYear, setCatalogUpdateCapacitySave, setCatalogUpdateDriveTrainSave, setCatalogUpdateEqClassCodeSave, setCatalogUpdateMakeSave, setCatalogUpdateNoOfDoorSave, setCatalogUpdatePowerTypeSave, setCatalogUpdateUpfitSave, setCatalogUpdateVehicleLevelSave, setCatalogUpdateYearSave, getCatalogUpdateEqClassCodeValidate, isBudgetingPercentOptionSaved, isBudgetingPercentOptionDeleted, isUsefulLifeOptionSaved, isUsefulLifeOptionDeleted, setCatalogUpdateModelSave, setCatalogRemoveModel, getCatalogUpdateModel, getCatalogUpdateModelValidate, setCatalogUpdateStateAvailabilitySave, setCatalogRemoveStateAvailability, setCatalogUpdateProgramStatusSave, setCatalogRemoveProgramStatus, setCatalogUpdateAnnualHoursSave, setCatalogRemoveAnnualHours, setCatalogUpdateDeckSizeSave, setCatalogRemoveDeckSize, setCatalogUpdateDeckTypeSave, setCatalogRemoveDeckType, setCatalogUpdateSizeSave, setCatalogRemoveSize, setCatalogUpdateLengthSave, setCatalogRemoveLength, setCatalogUpdateAutonomousSave, setCatalogRemoveAutonomous, setCatalogUpdateCategorySave, setCatalogRemoveCategory, setCatalogUpdateCategoryTypeSave, setCatalogRemoveCategoryType, getCatalogUpdateCategoryType, setCatalogUpdateCategory2Save, setCatalogRemoveCategory2, getCatalogUpdateCategory2, setCatalogUpdateTypeSave, setCatalogRemoveType, isTagsOptionSaved, isTagsOptionDeleted, setEditCatalogVehicleCapacity, setCatalogUpdateVehicleClassSave, setCatalogRemoveVehicleClass, setCatalogUpdateGroupTypeSave, setCatalogRemoveGroupType, setCatalogUpdateClassTypeSave, setCatalogRemoveClassType, setCatalogUpdateGrossWeightSave, setCatalogRemoveGrossWeight, setCatalogUpdateTrimSave, setCatalogRemoveTrim } from "Store/AssetManagement/CatalogItemDropDownUpdate/CatalogItemDropDownUpdateAction";
import permissions, { isAuthorized } from "client/utils/Permissions";

const statusOptions = [
  { value: '', label: 'Select Status' },
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' },
]

const CreateAssetContainer = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  let { id, actionType } = useParams();

  const [assetTypeOption, setAssetTypeOption] = useState<any>([])
  const [selectedMake, setSelectedMake] = useState<any>([]);
  const [selectedModel, setSelectedModel] = useState<any>();
  const [showAddModelModal, setShowAddModelModal] = useState(false);
  const [eqClassCode, setEqClassCode] = useState<any>();
  const [eqClassDescription, setEqClassDescription] = useState<any>();
  const [addEqClassCodeError, setAddEqClassCodeError] = useState<any>('');
  const [addEqClassDescriptionError, setAddEqClassDescriptionError] = useState<any>('');
  const [modelError, setModelError] = useState<any>('');
  const [modelMakeError, setModelMakeError] = useState<any>('');
  const [fieldValueError, setFieldValueError] = useState<any>('');

  const [addItemClicked, setAddItemClicked] = useState(false)
  const [showKitAttributeTable, setShowKitAttributeTable] = useState(false)
  const [list, setList] = useState<any>([])
  const [error, setError] = useState('')
  const [selectedAssetType, setSelectedAssetType] = useState<any>({})
  const [catalogItemValues, setCatalogItemValues] = useState<any>({})
  const [catalogItemErrors, setCatalogItemErrors] = useState<any>({})
  const [kitAttributeValues, setKitAttributeValues] = useState<any>([])
  const [vehicleTypeList, setVehicleTypeList] = useState<any>([])
  const [capacityList, setCapacityList] = useState<any>([])
  const [noOfDoorsList, setNoOfDoorsList] = useState<any>([])
  const [makeList, setMakeList] = useState<any>([])
  const [upfitOptionList, setUpfitOptionList] = useState<any>([])
  const [driveTrainList, setDriveTrainList] = useState<any>([])
  const [powerTypeList, setPowerTypeList] = useState<any>([])
  const [eqClassCodeList, setEqClassCodeList] = useState<any>([])
  const [budgetPercentList, setBudgetPercentList] = useState<any>([])
  const [vehicleLevelList, setVehicleLevelList] = useState<any>([])
  const [yearList, setYearList] = useState<any>([])
  const [useFulLifeList, setUseFulLifeList] = useState<any>([])
  const [attachmentsList, setAttachmentsList] = useState<any>([]);
  const [modelsList, setModelsList] = useState<any>([])
  const [classTypeList, setClassTypeList] = useState<any>([])
  const [groupTypeList, setGroupTypeList] = useState<any>([])
  const [vehicleClassList, setVehicleClassList] = useState<any>([])
  const [grossWeightList, setGrossWeightList] = useState<any>([])
  const [cdlList, setCdlList] = useState<any>([])
  const [trimList, setTrimList] = useState<any>([])
  const [useList, setUseList] = useState<any>([])
  const [filterModelPopup, setFilterModelPopup] = useState(false);
  const [filterEqClassCodePopup, setEqClassCodePopup] = useState(false);
  const [filterName, setFilterName] = useState('');
  const [ExistingDropDownValue, setExisitingDropDownValue] = useState<any>([]);

  //Mowers Dropdowns
  const [categoryList, setCategoryList] = useState<any>([])
  const [deckSizeList, setDeckSizeList] = useState<any>([])
  const [deckTypeList, setDeckTypeList] = useState<any>([])
  const [stateAvailabilityList, setStateAvailabilityList] = useState<any>([])
  const [programStatusList, setProgramStatusList] = useState<any>([])
  const [annualHoursList, setAnnualHoursList] = useState<any>([])
  const [autonomousList, setAutonomousList] = useState<any>([])
  const [sizeList, setsizeList] = useState<any>([])
  const [lengthList, setLengthList] = useState<any>([])
  const [seatingCapacityList, setSeatingCapacityList] = useState<any>([])
  const [enclosedCabList, setEnclosedCabList] = useState<any>([])
  const [category2List, setCategory2List] = useState<any>([])
  const [categoryTypeList, setCategoryTypeList] = useState<any>([])
  const [snowSetupList, setSnowSetupList] = useState<any>([])
  const [showEditPopup, setShowEditPopup] = useState<any>(false);

  const [typeList, setTypeList] = useState<any>([])

  const dispatchUploadAttachments = UploadAttachmentsDispatch.dispatchUploadAttachments(dispatch);
  const dispatchRemoveAttachment = UploadAttachmentsDispatch.dispatchRemoveAttachment(dispatch);


  useEffect(() => {
    setError('Error')
    setList([])
    dispatch(setIsCatalogItemSaved(undefined))
    dispatch(getAssetTypeOptions())
    if (id) {
      dispatch(setCatalogItemByAssetModelId({}))
      dispatch(getCatalogItemByAssetModelId(id))
      dispatch(setAllDropdownBySubTypeId([]))
      setCatalogItemValues(null)
    }
  }, [])

  const {
    allDropdownsBySubTypeId,
    docList,
    vehicleTypeDropdown,
    modelsListBasedOnMake,
    userData,
    isCatalogItemSaved,
    catalogItemByAssetModelId,
    category2ListBasedOnCategory,
    categoryTypeListBasedOnCategory,
    catalogUpdateNoOfDoors,
    isCatalogUpdateNoOfDoorSaved,
    catalogUpdateYear,
    isCatalogUpdateYearSaved,
    catalogUpdateCapacity,
    isCatalogUpdateCapacitySaved,
    catalogUpdateUpfit,
    isCatalogUpdateUpfitSaved,
    catalogUpdateDriveTrain,
    isCatalogUpdateDriveTrainSaved,
    catalogUpdatePowerType,
    isCatalogUpdatePowerTypeSaved,
    catalogUpdateVehicleLevel,
    isCatalogUpdateVehicleLevelSaved,
    isCatalogNoOfDoorRemoved,
    isCatalogYearRemoved,
    isCatalogCapacityRemoved,
    isCatalogUpfitRemoved,
    isCatalogDriveTrainRemoved,
    isCatalogPowerTypeRemoved,
    isCatalogVehicleLevelRemoved,
    catalogUpdateEqClassCode,
    isCatalogUpdateEqClassCodeSaved,
    isCatalogEqClassCodeRemoved,
    catalogUpdateMake,
    isCatalogUpdateMakeSaved,
    isCatalogMakeRemoved,
    catalogUpdateStateAvailability,
    isCatalogUpdateStateAvailabilitySaved,
    isCatalogStateAvailabilityRemoved,
    catalogUpdateModel,
    isCatalogUpdateModelSaved,
    isCatalogModelRemoved,
    budgetingPercentOptionsList,
    isBudgetingPercentOptionsSaved,
    isBudgetingPercentOptionsDeleted,
    isUsefulLifeOptionsDeleted,
    isUsefulLifeOptionsSaved,
    usefulLifeOptionsList,
    isTagsOptionsDeleted,
    isTagsOptionsSaved,
    tagsOptionsList,
    catalogUpdateProgramStatus,
    isCatalogUpdateProgramStatusSaved,
    isCatalogProgramStatusRemoved,
    catalogUpdateAnnualHours,
    isCatalogUpdateAnnualHoursSaved,
    isCatalogAnnualHoursRemoved,
    catalogUpdateDeckSize,
    isCatalogUpdateDeckSizeSaved,
    isCatalogDeckSizeRemoved,
    catalogUpdateDeckType,
    isCatalogUpdateDeckTypeSaved,
    isCatalogDeckTypeRemoved,
    catalogUpdateSize,
    isCatalogUpdateSizeSaved,
    isCatalogSizeRemoved,
    catalogUpdateLength,
    isCatalogUpdateLengthSaved,
    isCatalogLengthRemoved,
    catalogUpdateAutonomous,
    isCatalogUpdateAutonomousSaved,
    isCatalogAutonomousRemoved,
    catalogUpdateCategory,
    isCatalogUpdateCategorySaved,
    isCatalogCategoryRemoved,
    catalogUpdateCategoryType,
    isCatalogUpdateCategoryTypeSaved,
    isCatalogCategoryTypeRemoved,
    catalogUpdateCategory2,
    isCatalogUpdateCategory2Saved,
    isCatalogCategory2Removed,
    catalogUpdateType,
    isCatalogUpdateTypeSaved,
    isCatalogTypeRemoved,
    isSelectedVehicleLevelValid,
    assetTypeOptionsList,
    isVehicleCapacityEdited,
    catalogUpdateVehicleClass,
    isCatalogUpdateVehicleClassSaved,
    isCatalogVehicleClassRemoved,
    catalogUpdateGroupType,
    isCatalogUpdateGroupTypeSaved,
    isCatalogGroupTypeRemoved,
    catalogUpdateClassType,
    isCatalogUpdateClassTypeSaved,
    isCatalogClassTypeRemoved,
    catalogUpdateGrossWeight,
    isCatalogUpdateGrossWeightSaved,
    isCatalogGrossWeightRemoved,
    catalogUpdateTrim,
    isCatalogUpdateTrimSaved,
    isCatalogTrimRemoved,
  }: any = useSelector(
    (state: any) => ({
      allDropdownsBySubTypeId: state.CatalogManagementReducer.allDropdownsBySubTypeId,
      modelsListBasedOnMake: state.CatalogManagementReducer.modelsListBasedOnMake,
      docList: state.UploadAttachmentsReducer.list,
      vehicleTypeDropdown: state.AssetManagement.AssetType,
      userData: userProfileSelectors.getUserDetails(state),
      isCatalogItemSaved: state.CatalogManagementReducer.isCatalogItemSaved,
      catalogItemByAssetModelId: state.CatalogManagementReducer.catalogItemByAssetModelId,
      category2ListBasedOnCategory: state.CatalogManagementReducer.category2ListBasedOnCategory,
      categoryTypeListBasedOnCategory: state.CatalogManagementReducer.categoryTypeListBasedOnCategory,
      catalogUpdateNoOfDoors: state.CatalogDropDownUpdateReducers.catalogUpdateNoOfDoors,
      isCatalogUpdateNoOfDoorSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateNoOfDoorSaved,
      catalogUpdateYear: state.CatalogDropDownUpdateReducers.catalogUpdateYear,
      isCatalogUpdateYearSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateYearSaved,
      catalogUpdateCapacity: state.CatalogDropDownUpdateReducers.catalogUpdateCapacity,
      isCatalogUpdateCapacitySaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateCapacitySaved,
      catalogUpdateUpfit: state.CatalogDropDownUpdateReducers.catalogUpdateUpfit,
      isCatalogUpdateUpfitSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateUpfitSaved,
      catalogUpdateDriveTrain: state.CatalogDropDownUpdateReducers.catalogUpdateDriveTrain,
      isCatalogUpdateDriveTrainSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateDriveTrainSaved,
      catalogUpdatePowerType: state.CatalogDropDownUpdateReducers.catalogUpdatePowerType,
      isCatalogUpdatePowerTypeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdatePowerTypeSaved,
      catalogUpdateVehicleLevel: state.CatalogDropDownUpdateReducers.catalogUpdateVehicleLevel,
      isCatalogUpdateVehicleLevelSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateVehicleLevelSaved,
      isCatalogNoOfDoorRemoved: state.CatalogDropDownUpdateReducers.isCatalogNoOfDoorRemoved,
      isCatalogYearRemoved: state.CatalogDropDownUpdateReducers.isCatalogYearRemoved,
      isCatalogCapacityRemoved: state.CatalogDropDownUpdateReducers.isCatalogCapacityRemoved,
      isCatalogUpfitRemoved: state.CatalogDropDownUpdateReducers.isCatalogUpfitRemoved,
      isCatalogDriveTrainRemoved: state.CatalogDropDownUpdateReducers.isCatalogDriveTrainRemoved,
      isCatalogPowerTypeRemoved: state.CatalogDropDownUpdateReducers.isCatalogPowerTypeRemoved,
      isCatalogVehicleLevelRemoved: state.CatalogDropDownUpdateReducers.isCatalogVehicleLevelRemoved,
      catalogUpdateEqClassCode: state.CatalogDropDownUpdateReducers.catalogUpdateEqClassCode,
      isCatalogUpdateEqClassCodeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateEqClassCodeSaved,
      isCatalogEqClassCodeRemoved: state.CatalogDropDownUpdateReducers.isCatalogEqClassCodeRemoved,
      catalogUpdateMake: state.CatalogDropDownUpdateReducers.catalogUpdateMake,
      isCatalogUpdateMakeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateMakeSaved,
      isCatalogMakeRemoved: state.CatalogDropDownUpdateReducers.isCatalogMakeRemoved,
      catalogUpdateStateAvailability: state.CatalogDropDownUpdateReducers.catalogUpdateStateAvailability,
      isCatalogUpdateStateAvailabilitySaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateStateAvailabilitySaved,
      isCatalogStateAvailabilityRemoved: state.CatalogDropDownUpdateReducers.isCatalogStateAvailabilityRemoved,
      catalogUpdateModel: state.CatalogDropDownUpdateReducers.catalogUpdateModel,
      isCatalogUpdateModelSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateModelSaved,
      isCatalogModelRemoved: state.CatalogDropDownUpdateReducers.isCatalogModelRemoved,
      budgetingPercentOptionsList: state.CatalogDropDownUpdateReducers.budgetingPercentOptionsList,
      isBudgetingPercentOptionsSaved: state.CatalogDropDownUpdateReducers.isBudgetingPercentOptionsSaved,
      isBudgetingPercentOptionsDeleted: state.CatalogDropDownUpdateReducers.isBudgetingPercentOptionsDeleted,
      isUsefulLifeOptionsDeleted: state.CatalogDropDownUpdateReducers.isUsefulLifeOptionsDeleted,
      isUsefulLifeOptionsSaved: state.CatalogDropDownUpdateReducers.isUsefulLifeOptionsSaved,
      usefulLifeOptionsList: state.CatalogDropDownUpdateReducers.usefulLifeOptionsList,
      isTagsOptionsDeleted: state.CatalogDropDownUpdateReducers.isTagsOptionsDeleted,
      isTagsOptionsSaved: state.CatalogDropDownUpdateReducers.isTagsOptionsSaved,
      tagsOptionsList: state.CatalogDropDownUpdateReducers.tagsOptionsList,
      catalogUpdateProgramStatus: state.CatalogDropDownUpdateReducers.catalogUpdateProgramStatus,
      isCatalogUpdateProgramStatusSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateProgramStatusSaved,
      isCatalogProgramStatusRemoved: state.CatalogDropDownUpdateReducers.isCatalogProgramStatusRemoved,
      catalogUpdateAnnualHours: state.CatalogDropDownUpdateReducers.catalogUpdateAnnualHours,
      isCatalogUpdateAnnualHoursSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateAnnualHoursSaved,
      isCatalogAnnualHoursRemoved: state.CatalogDropDownUpdateReducers.isCatalogAnnualHoursRemoved,
      catalogUpdateDeckSize: state.CatalogDropDownUpdateReducers.catalogUpdateDeckSize,
      isCatalogUpdateDeckSizeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateDeckSizeSaved,
      isCatalogDeckSizeRemoved: state.CatalogDropDownUpdateReducers.isCatalogDeckSizeRemoved,
      catalogUpdateDeckType: state.CatalogDropDownUpdateReducers.catalogUpdateDeckType,
      isCatalogUpdateDeckTypeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateDeckTypeSaved,
      isCatalogDeckTypeRemoved: state.CatalogDropDownUpdateReducers.isCatalogDeckTypeRemoved,
      catalogUpdateSize: state.CatalogDropDownUpdateReducers.catalogUpdateSize,
      isCatalogUpdateSizeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateSizeSaved,
      isCatalogSizeRemoved: state.CatalogDropDownUpdateReducers.isCatalogSizeRemoved,
      catalogUpdateLength: state.CatalogDropDownUpdateReducers.catalogUpdateLength,
      isCatalogUpdateLengthSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateLengthSaved,
      isCatalogLengthRemoved: state.CatalogDropDownUpdateReducers.isCatalogLengthRemoved,
      catalogUpdateAutonomous: state.CatalogDropDownUpdateReducers.catalogUpdateAutonomous,
      isCatalogUpdateAutonomousSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateAutonomousSaved,
      isCatalogAutonomousRemoved: state.CatalogDropDownUpdateReducers.isCatalogAutonomousRemoved,
      catalogUpdateCategory: state.CatalogDropDownUpdateReducers.catalogUpdateCategory,
      isCatalogUpdateCategorySaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateCategorySaved,
      isCatalogCategoryRemoved: state.CatalogDropDownUpdateReducers.isCatalogCategoryRemoved,
      catalogUpdateCategoryType: state.CatalogDropDownUpdateReducers.catalogUpdateCategoryType,
      isCatalogUpdateCategoryTypeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateCategoryTypeSaved,
      isCatalogCategoryTypeRemoved: state.CatalogDropDownUpdateReducers.isCatalogCategoryTypeRemoved,
      catalogUpdateCategory2: state.CatalogDropDownUpdateReducers.catalogUpdateCategory2,
      isCatalogUpdateCategory2Saved: state.CatalogDropDownUpdateReducers.isCatalogUpdateCategory2Saved,
      isCatalogCategory2Removed: state.CatalogDropDownUpdateReducers.isCatalogCategory2Removed,
      catalogUpdateType: state.CatalogDropDownUpdateReducers.catalogUpdateType,
      isCatalogUpdateTypeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateTypeSaved,
      isCatalogTypeRemoved: state.CatalogDropDownUpdateReducers.isCatalogTypeRemoved,
      isSelectedVehicleLevelValid: state.CatalogManagementReducer.isSelectedVehicleLevelValid,
      assetTypeOptionsList: state.CatalogManagementReducer.assetTypeOptionsList,
      isVehicleCapacityEdited: state.CatalogDropDownUpdateReducers.isVehicleCapacityEdited,
      catalogUpdateVehicleClass: state.CatalogDropDownUpdateReducers.catalogUpdateVehicleClass,
      isCatalogUpdateVehicleClassSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateVehicleClassSaved,
      isCatalogVehicleClassRemoved: state.CatalogDropDownUpdateReducers.isCatalogVehicleClassRemoved,
      catalogUpdateGroupType: state.CatalogDropDownUpdateReducers.catalogUpdateGroupType,
      isCatalogUpdateGroupTypeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateGroupTypeSaved,
      isCatalogGroupTypeRemoved: state.CatalogDropDownUpdateReducers.isCatalogGroupTypeRemoved,
      catalogUpdateClassType: state.CatalogDropDownUpdateReducers.catalogUpdateClassType,
      isCatalogUpdateClassTypeSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateClassTypeSaved,
      isCatalogClassTypeRemoved: state.CatalogDropDownUpdateReducers.isCatalogClassTypeRemoved,
      catalogUpdateGrossWeight: state.CatalogDropDownUpdateReducers.catalogUpdateGrossWeight,
      isCatalogUpdateGrossWeightSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateGrossWeightSaved,
      isCatalogGrossWeightRemoved: state.CatalogDropDownUpdateReducers.isCatalogGrossWeightRemoved,
      catalogUpdateTrim: state.CatalogDropDownUpdateReducers.catalogUpdateTrim,
      isCatalogUpdateTrimSaved: state.CatalogDropDownUpdateReducers.isCatalogUpdateTrimSaved,
      isCatalogTrimRemoved: state.CatalogDropDownUpdateReducers.isCatalogTrimRemoved,
    })
  )

  useEffect(() => {
    if (userData?.permissions?.length > 0) {
      if (!(isAuthorized(permissions.ViewCatalog) || isAuthorized(permissions.CreateEditCatalog))) {
        navigate('/ordermanagement/blank');
      }
    }
  }, [userData?.permissions])

  useEffect(() => {
    setAttachmentsList(docList);
  }, [docList]);

  useEffect(()=>{
    if(assetTypeOptionsList?.length){
      let assetTypes = assetTypeOptionsList?.reduce((acc: any[], type: any)=> {
        if(type !== CONSTANTS?.TREE_CARE){
          acc.push({label: type?.text, id: type?.value, value: type?.text})
          return acc
        }
        return acc
      }, [])
      assetTypes.unshift( { value: '', label: 'Select Asset Type' })
      setAssetTypeOption(assetTypes)
    } else {
      setAssetTypeOption([])
    }
  }, [assetTypeOptionsList])

  const getAllDropdownsFromAssetDetailsById = (subTypeId: any, assetModelDropdowns: any) => {
    if (subTypeId === 1) {
      return assetModelDropdowns?.find((list: any) => list?.equipmentType === CONSTANTS.MANAGEMENT_VEHICLE)?.data ?? []
    } else if (subTypeId === 2) {
      return assetModelDropdowns?.find((list: any) => list?.equipmentType === CONSTANTS.PRODUCTION_VEHICLE)?.data ?? []
    } else {
      return assetModelDropdowns[0].data ?? []
    }
  }

  useEffect(() => {
    if (catalogItemByAssetModelId?.assetModelId && id) {
      const selectedVehicleTypeDropdownList = getAllDropdownsFromAssetDetailsById(catalogItemByAssetModelId?.orderRequestSubTypeId, catalogItemByAssetModelId?.assetModelDropdowns)
      createDropDownOptions(selectedVehicleTypeDropdownList)
      !vehicleTypeDropdown?.length && dispatch(getAssetType())
      setAddItemClicked(true)
      if (catalogItemByAssetModelId.requestType == CONSTANTS.VEHICLE) {
        setSelectedAssetType({ assetType: assetTypeOption?.find((i: any) => i.value == catalogItemByAssetModelId.requestType) })
      } else {
        setSelectedAssetType({ assetType: assetTypeOption?.find((i: any) => i.id == catalogItemByAssetModelId.orderRequestSubTypeId) })
      }
    }
  }, [catalogItemByAssetModelId])

  const createDropDownOptions = (dropDowns: any) => {
    dropDowns?.map((item: any) => {
      if (item?.dropdownName == "Vehicle Type") {
        const defaultVehicleType = {
          text: "Select Class Type",
          value: null
        };
        item?.dropdownList?.unshift(defaultVehicleType);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value, showVehicleCapacity: val.selected })
        );
        setClassTypeList(options)
      } else if (item?.dropdownName == "Truck Size") {
        const defaultCapacity = {
          text: "Select Capacity",
          value: null
        };
        item?.dropdownList?.unshift(defaultCapacity);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setCapacityList(options)
      } else if (item?.dropdownName == "No. of Doors") {
        const defaultDoors = {
          text: "Select No. of Doors",
          value: null
        };
        item?.dropdownList?.unshift(defaultDoors);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setNoOfDoorsList(options)
      } else if (item?.dropdownName == "Make" || item?.dropdownName == "Manufacturer") {
        const defaultMake = {
          text: "Select Make",
          value: null
        };
        item?.dropdownList?.unshift(defaultMake);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setMakeList(options)
      } else if (item?.dropdownName == "Upfit Option") {
        const defaultUpfitOption = {
          text: "Select Upfit Option",
          value: null
        };
        item?.dropdownList?.unshift(defaultUpfitOption);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setUpfitOptionList(options)
      } else if (item?.dropdownName == "Drive Train") {
        const defaultDriveTrain = {
          text: "Select Drive Train",
          value: null
        };
        item?.dropdownList?.unshift(defaultDriveTrain);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setDriveTrainList(options)
      } else if (item?.dropdownName == "Snow Setup") {
        const defaultSnowSetup = {
          text: "Select Snow Setup",
          value: null
        };
        item?.dropdownList?.unshift(defaultSnowSetup);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setSnowSetupList(options)
      } else if (item?.dropdownName == "Fuel Type") {
        const defaultPowerType = {
          text: "Select Power Type",
          value: null
        };
        item?.dropdownList?.unshift(defaultPowerType);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setPowerTypeList(options)
      } else if (item?.dropdownName == "Budgeting Percent") {
        const defaultBudgetPercent = {
          text: "Select Budget Percent",
          value: null
        };
        item?.dropdownList?.unshift(defaultBudgetPercent);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: (val.text + '%'), key: val.value })
        );
        setBudgetPercentList(options)
        setCatalogItemValues((prev: any) => ({ ...prev, budgetingPercent: options?.find((i: any) => i.label == "10%") }))
      } else if (item?.dropdownName == "EqClassCode") {
        const defaultEqClassCode = {
          text: "Select Eq Class Code",
          value: null
        };
        item?.dropdownList?.unshift(defaultEqClassCode);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setEqClassCodeList(options)
      } else if (item?.dropdownName == "VehicleLevel") {
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setVehicleLevelList(options)
      } else if (item?.dropdownName == "Useful Life / Lease Terms") {
        const defaultUseFulLife = {
          text: "Select UseFulLife/LeaseTerms",
          value: null
        };
        item?.dropdownList?.unshift(defaultUseFulLife);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setUseFulLifeList(options)
      } else if (item?.dropdownName == "Year") {
        const defaultYear = {
          text: "Select Year",
          value: null
        };
        item?.dropdownList?.unshift(defaultYear);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setYearList(options)
      } else if (item?.dropdownName == "Category" || item?.dropdownName == 'Style') {
        const defaultCategory = {
          text: "Select Category",
          value: null
        };
        item?.dropdownList?.unshift(defaultCategory);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setCategoryList(options)
      } else if (item?.dropdownName == "Deck Size") {
        const defaultDeckSize = {
          text: "Select Deck Size",
          value: null
        };
        item?.dropdownList?.unshift(defaultDeckSize);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setDeckSizeList(options)
      } else if (item?.dropdownName == "Deck Type") {
        const defaultDeckType = {
          text: "Select Deck Type",
          value: null
        };
        item?.dropdownList?.unshift(defaultDeckType);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setDeckTypeList(options)
      } else if (item?.dropdownName == "State Availability") {
        const defaultStateAvailability = {
          text: "Select State Availability",
          value: null
        };
        item?.dropdownList?.unshift(defaultStateAvailability);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setStateAvailabilityList(options)
      } else if (item?.dropdownName == "Program Status") {
        const defaultProgramStatus = {
          text: "Select Program Status",
          value: null
        };
        item?.dropdownList?.unshift(defaultProgramStatus);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setProgramStatusList(options)
      } else if (item?.dropdownName == "Annual Hours") {
        const defaultAnnualHours = {
          text: "Select Annual Hours",
          value: null
        };
        item?.dropdownList?.unshift(defaultAnnualHours);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setAnnualHoursList(options)
      } else if (item?.dropdownName == "Autonomous") {
        const defaultAutonomous = {
          text: "Select Autonomous",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setAutonomousList(options)
      } else if (item?.dropdownName == "Size") {
        const defaultAutonomous = {
          text: "Select Size",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setsizeList(options)
      } else if (item?.dropdownName == "Length") {
        const defaultAutonomous = {
          text: "Select Length",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setLengthList(options)
      } else if (item?.dropdownName == "Seating Capacity") {
        const defaultAutonomous = {
          text: "Select Seating Capacity",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setSeatingCapacityList(options)
      } else if (item?.dropdownName == "Capacity") {
        const defaultAutonomous = {
          text: "Select Capacity",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setCapacityList(options)
      } else if (item?.dropdownName == "Enclosed Cab") {
        const defaultAutonomous = {
          text: "Select Enclosed Cab",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setEnclosedCabList(options)
      } else if (item?.dropdownName == "Vehicle Class") {
        const defaultAutonomous = {
          text: "Select Vehicle Class",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setVehicleClassList(options)
      } else if (item?.dropdownName == "Group Type") {
        const defaultAutonomous = {
          text: "Select Group Type",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setGroupTypeList(options)
      } else if (item?.dropdownName == "Gross Vehicle Weight Rating") {
        const defaultAutonomous = {
          text: "Select Gross Vehicle Weight Rating",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setGrossWeightList(options)
      } else if (item?.dropdownName == "CDL Required") {
        const defaultAutonomous = {
          text: "Select CDL Required",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setCdlList(options)
      } else if (item?.dropdownName == "Trim") {
        const defaultAutonomous = {
          text: "Select Trim",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setTrimList(options)
      } else if (item?.dropdownName == "Use (Tags)") {
        const defaultAutonomous = {
          text: "Select Use (Tags)",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setUseList(options)
      } else if (item?.dropdownName == "Type") {
        const defaultAutonomous = {
          text: "Select Type",
          value: null
        };
        item?.dropdownList?.unshift(defaultAutonomous);
        let options = item?.dropdownList?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setTypeList(options)
      }
    })
    setCatalogItemValues((prev: any) => ({ ...prev, status: statusOptions?.find((i: any) => i.value == "active") }))
  }

  useEffect(() => {
    if (id && id == catalogItemByAssetModelId?.assetModelId && (catalogItemValues?.vehicleType?.label == catalogItemByAssetModelId?.orderRequestSubType || catalogItemValues?.vehicleType?.label == null || catalogItemValues?.vehicleType?.label == "" || catalogItemValues?.vehicleType?.label == undefined)) {
      let vehicleLevelTemp = catalogItemByAssetModelId?.vehicleLevel?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setList(catalogItemByAssetModelId?.attachments ?? [])
      setAttachmentsList(catalogItemByAssetModelId?.attachments ?? [])
      let makeListTemp = makeList?.find((make: any) => make.label == catalogItemByAssetModelId?.make)
      setCatalogItemValues({
        nap: !catalogItemByAssetModelId?.isNationalAccountPricing,
        assetModelId: catalogItemByAssetModelId?.assetModelId,
        vehicleType: {
          value: catalogItemByAssetModelId?.orderRequestSubTypeId, 
          key: catalogItemByAssetModelId?.orderRequestSubTypeId, 
          label: catalogItemByAssetModelId?.orderRequestSubType, 
          orderRequestSubTypeId: catalogItemByAssetModelId?.orderRequestSubTypeId, 
          orderRequestType: catalogItemByAssetModelId?.orderRequestSubType
        },
        vehicleLevel: vehicleLevelTemp,
        make: catalogItemByAssetModelId?.requestType == CONSTANTS.VEHICLE ? { label: catalogItemByAssetModelId?.make, value: makeListTemp?.value } : null,
        manufacturer: { label: catalogItemByAssetModelId?.manufacturer, value: catalogItemByAssetModelId?.manufacturerId },
        model: { label: catalogItemByAssetModelId?.model, value: catalogItemByAssetModelId?.model },
        year: { label: catalogItemByAssetModelId?.year, value: catalogItemByAssetModelId?.year },
        noOfDoors: { label: catalogItemByAssetModelId?.noOfDoors, value: catalogItemByAssetModelId?.noOfDoorsId },
        capacity: { label: catalogItemByAssetModelId?.capacity, value: catalogItemByAssetModelId?.capacityId },
        truckSize: { label: catalogItemByAssetModelId?.truckSize, value: catalogItemByAssetModelId?.truckSizeId },
        bvSpec: catalogItemByAssetModelId?.bvSpecNo,
        upfit: { label: catalogItemByAssetModelId?.upfitOption, value: catalogItemByAssetModelId?.upfitOptionId },
        eqClassCode: { label: catalogItemByAssetModelId?.eqClassCode, value: catalogItemByAssetModelId?.eqClassCodeId },
        driveTrain: { label: catalogItemByAssetModelId?.driveTrain, value: catalogItemByAssetModelId?.driveTrainId },
        snowSetup: { label: catalogItemByAssetModelId?.snowSetup, value: catalogItemByAssetModelId?.snowSetupId },
        fuelType: { label: catalogItemByAssetModelId?.fuelType, value: catalogItemByAssetModelId?.fuelTypeId },
        catalogDescription: catalogItemByAssetModelId?.catalogDescription,
        eOneDescription: catalogItemByAssetModelId?.eOneDescription,
        detailedDescription: catalogItemByAssetModelId?.description,
        poDescription1: catalogItemByAssetModelId?.poDesc1,
        poDescription2: catalogItemByAssetModelId?.poDesc2,
        actualPrice: formatPrice((catalogItemByAssetModelId?.budgetInfo?.actualPrice ?? 0), 2),
        budgetingPercent: { label: (catalogItemByAssetModelId?.budgetInfo?.budgetingPercent + '%' ), value: catalogItemByAssetModelId?.budgetInfo?.budgetingPercent },
        budgetingPrice: formatPrice((catalogItemByAssetModelId?.budgetInfo?.budgetingPrice ?? 0), 2),
        leaseTerm: { label: catalogItemByAssetModelId?.budgetInfo?.usefulLifeOrLeaseTerm, value: catalogItemByAssetModelId?.budgetInfo?.usefulLifeOrLeaseTerm },
        monthlyDeprecation: formatPrice((catalogItemByAssetModelId?.budgetInfo?.monthlyDepreciation ?? 0), 2),
        logoed: { value: catalogItemByAssetModelId?.budgetInfo?.logoed, label: catalogItemByAssetModelId?.budgetInfo?.logoed },
        status: catalogItemByAssetModelId?.status ? { value: 'active', label: 'Active' } : { value: 'inactive', label: 'Inactive' },
        price: formatPrice((catalogItemByAssetModelId?.price ?? 0), 2),
        stateAvailability: { label: catalogItemByAssetModelId?.stateAvailability, value: catalogItemByAssetModelId?.stateAvailabilityId },
        programStatus: { label: catalogItemByAssetModelId?.programStatus, value: catalogItemByAssetModelId?.programStatusId },
        annualHours: { label: catalogItemByAssetModelId?.annualHours, value: catalogItemByAssetModelId?.annualHoursId },
        deckSize: { label: catalogItemByAssetModelId?.deckSize, value: catalogItemByAssetModelId?.deckSizeId },
        deckType: { label: catalogItemByAssetModelId?.deckType, value: catalogItemByAssetModelId?.deckTypeId },
        autonomous: { label: catalogItemByAssetModelId?.autonomous, value: catalogItemByAssetModelId?.autonomousId },
        category: catalogItemByAssetModelId?.categoryId ? { label: catalogItemByAssetModelId?.category, value: catalogItemByAssetModelId?.categoryId } : { label: catalogItemByAssetModelId?.style, value: catalogItemByAssetModelId?.styleId },
        size: { label: catalogItemByAssetModelId?.size, value: catalogItemByAssetModelId?.sizeId },
        length: { label: catalogItemByAssetModelId?.length, value: catalogItemByAssetModelId?.lengthId },
        seatingCapacity: { label: catalogItemByAssetModelId?.seatingCapacity, value: catalogItemByAssetModelId?.seatingCapacityId },
        enclosedCab: { label: catalogItemByAssetModelId?.enclosedCab, value: catalogItemByAssetModelId?.enclosedCabId },
        classType: {label: catalogItemByAssetModelId?.vehicleType, value: catalogItemByAssetModelId?.vehicleTypeId},
        groupType: { label: catalogItemByAssetModelId?.groupType, value: catalogItemByAssetModelId?.groupTypeId },
        vehicleClass: { label: catalogItemByAssetModelId?.vehicleClass, value: catalogItemByAssetModelId?.vehicleClassId },
        vehicleGrossWeightRating: grossWeightList?.find((option: any) => option.value == catalogItemByAssetModelId?.grossVehicleWeightRatingId),
        cdl: cdlList?.find((option: any) => option.value == catalogItemByAssetModelId?.cdlRequiredId),
        trim: trimList?.find((option: any) => option.value == catalogItemByAssetModelId?.trimId),
        use: { label: catalogItemByAssetModelId?.useTag, value: catalogItemByAssetModelId?.useTagId },
        category2: { label: catalogItemByAssetModelId?.category2, value: catalogItemByAssetModelId?.category2Id?.toString() },
        categoryType: { label: catalogItemByAssetModelId?.categoryType, value: catalogItemByAssetModelId?.categoryTypeId?.toString() },
        type: { label: catalogItemByAssetModelId?.type, value: catalogItemByAssetModelId?.typeId }
      })
      if (catalogItemByAssetModelId?.equipmentKitAttributes?.length) {
        setShowKitAttributeTable(true)
        let kitValues: any = []
        catalogItemByAssetModelId?.equipmentKitAttributes?.map((kitItem?: any) => {
          let kitValuesTemp ={kitDescription1 : kitItem?.kitDescription1,
            kitDescription2 : kitItem?.kitDescription2,
            kitNumber : kitItem?.kitNumber,
            quantity : kitItem?.quantity,
            unitPrice : formatPrice(kitItem?.unitPrice, 2)}
            kitValues.push(kitValuesTemp)
        })
        setKitAttributeValues(kitValues)
      }
      if (catalogItemByAssetModelId?.poDesc1?.length > 30) {
        validateCatalogItemValues(catalogItemByAssetModelId?.poDesc1, 'poDescription1')
      }
      if (catalogItemByAssetModelId?.poDesc2?.length > 30) {
        validateCatalogItemValues(catalogItemByAssetModelId?.poDesc2, 'poDescription2')
      }
    }
  }, [vehicleTypeDropdown, makeList, yearList, vehicleLevelList])

  useEffect(() => {
    if (catalogItemValues?.make?.value && catalogItemValues?.vehicleType && id) {
      dispatch(getModelsBasedOnMake(catalogItemValues?.make?.value, catalogItemValues?.vehicleType?.label))
    } else if (catalogItemValues?.manufacturer?.value && id) {
      dispatch(getEquipmentModelsBasedOnMake(catalogItemValues?.manufacturer?.value, selectedAssetType?.assetType?.value))
    }
  }, [catalogItemValues?.make, catalogItemValues?.manufacturer, id])

  useEffect(() => {
    if (catalogItemValues?.category && id && catalogItemByAssetModelId?.category2) {
      dispatch(getCategory2BasedOnCategory(catalogItemValues?.category?.value))
    }
  }, [catalogItemValues?.category, id, catalogItemByAssetModelId?.category2])

  useEffect(() => {
    if (catalogItemValues?.category && id && catalogItemByAssetModelId?.categoryType) {
      dispatch(getCategoryTypeBasedOnCategory(catalogItemValues?.category?.value))
    }
  }, [catalogItemValues?.category, id, catalogItemByAssetModelId?.categoryType])

  ///Modified dropDown values as required
  useEffect(() => {
    if (selectedAssetType?.assetType?.value && allDropdownsBySubTypeId?.length) {
      let AllVehicledropdownList: any = allDropdownsBySubTypeId?.length ? JSON.parse(JSON.stringify(allDropdownsBySubTypeId)) : []
      if (selectedAssetType?.assetType?.value === CONSTANTS.VEHICLE) {

        if (catalogItemValues?.vehicleType?.value) {
          const selectedVehicleTypeDropdownList = catalogItemValues?.vehicleType?.value === 2 ? (AllVehicledropdownList?.find((list: any) => list?.equipmentType === CONSTANTS.PRODUCTION_VEHICLE)?.data ?? []) : (AllVehicledropdownList?.find((list: any) => list?.equipmentType === CONSTANTS.MANAGEMENT_VEHICLE)?.data ?? [])
          if (selectedVehicleTypeDropdownList?.length > 0) {
            createDropDownOptions(selectedVehicleTypeDropdownList)
          }
        }
      }
      else {
        createDropDownOptions(AllVehicledropdownList[0]?.data)
      }
    }
  }, [allDropdownsBySubTypeId, catalogItemValues?.vehicleType?.value])

  useEffect(() => {
    if (modelsListBasedOnMake) {
      const defaultModel = {
        label: "Select Model",
        value: null
      };
      let options = modelsListBasedOnMake?.map((val: any) =>
        ({ value: val.text, label: val.text, key: val.value })
      );
      options?.unshift(defaultModel);
      setModelsList(options)
    }
  }, [modelsListBasedOnMake])

  useEffect(() => {
    if (category2ListBasedOnCategory) {
      const defaultModel = {
        label: "Select Category 2",
        value: null
      };
      let options = category2ListBasedOnCategory?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      options?.unshift(defaultModel);
      setCategory2List(options)
    }
  }, [category2ListBasedOnCategory])

  useEffect(() => {
    if (categoryTypeListBasedOnCategory) {
      const defaultModel = {
        label: "Select Category Type",
        value: null
      };
      let options = categoryTypeListBasedOnCategory?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      options?.unshift(defaultModel);
      setCategoryTypeList(options)
    }
  }, [categoryTypeListBasedOnCategory])

  useEffect(() => {
    if (isCatalogItemSaved) {
      setPopupcontentComplete({
        ...PopupcontentComplete,
        titleImg: isCatalogItemSaved === 'success' ? SuccessBee : ConfirmationBee,
        title: isCatalogItemSaved === 'success' ? "SUCCESS" : "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: isCatalogItemSaved === 'success' ? (id ? `${selectedAssetType?.assetType?.value} Asset has been updated successfully.` : `${selectedAssetType?.assetType?.value} Asset has been created successfully.`) : 'Error occured while creating Asset.',
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclickComplete: () => {
          if (isCatalogItemSaved === 'success') {
            handleClickBack()
          } else {
            hideDialogComplete()
          }
        }
      });
      dispatch(setIsCatalogItemSaved(null))
    }
  }, [isCatalogItemSaved])

  useEffect(()=>{
    if(isSelectedVehicleLevelValid){
      if(!isSelectedVehicleLevelValid?.status){
        const inValidLevelList = isSelectedVehicleLevelValid?.message?.split(",")
        const invalidLevelsText = catalogItemValues?.vehicleLevel?.reduce((acc: any, curr: any) => {
          if(inValidLevelList?.includes(curr?.value)){
            acc.push(curr?.label)
            return acc
          }
          return acc
        }, [])
        
        let text = `Driver Title not available for ${invalidLevelsText?.join(', ')}`;

        setPopupcontentComplete({
          ...PopupcontentComplete,
          titleImg: ConfirmationBee,
          title: "INFORMATION",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: text,
          outlineBtnText: "Close",
          isSingleConfirmationBtn: true,
          popupOutlinebtnOnclickComplete: () => {
            hideDialogComplete()
            const tempVehicleLevel = catalogItemValues?.vehicleLevel?.filter((level: any) => !inValidLevelList?.includes(String(level?.value)))
            setCatalogItemValues((prev: any) => ({ ...prev, vehicleLevel: tempVehicleLevel }))
          },
          dismissPopup: () => {
            hideDialogComplete()
            const tempVehicleLevel = catalogItemValues?.vehicleLevel?.filter((level: any) => !inValidLevelList?.includes(String(level?.value)))
            setCatalogItemValues((prev: any) => ({ ...prev, vehicleLevel: tempVehicleLevel }))
          }
        });
      }
      dispatch(setIsSelectedVehicleLevelValid(null))
    }
  }, [isSelectedVehicleLevelValid])

  const breadcrumlist = [
    {
      text: "Catalog Management",
      key: "f1",
      href: "/ordermanagement/catalogmanagement",
      onClick: (e: any) => {
        e.preventDefault();
        handleClickCancel();
        // handleClickBack()
      },
    },
    { text: (id ? `${actionType == 'edit' ? 'Edit' : 'Copy'} Asset` : "Create New Asset Type"), key: "f4" },
  ];


  const handleClickBack = () => {
    setCatalogItemValues({})
    setAddItemClicked(false)
    setSelectedAssetType({})
    setCatalogItemErrors({})
    setShowKitAttributeTable(false)
    setAttachmentsList([])
    dispatchRemoveAttachment([])
    dispatch(setIsCatalogItemSaved(undefined))
    navigate('/ordermanagement/catalogmanagement')
    dispatch(setCatalogItemByAssetModelId({}))
    clearLocalStateDropdowns()
  }

  const clearLocalStateDropdowns = () => {
    setVehicleTypeList([])
    setCapacityList([])
    setNoOfDoorsList([])
    setMakeList([])
    setUpfitOptionList([])
    setDriveTrainList([])
    setSnowSetupList([])
    setPowerTypeList([])
    setEqClassCodeList([])
    setBudgetPercentList([])
    setVehicleLevelList([])
    setYearList([])
    setUseFulLifeList([])
    setAttachmentsList([])
    setModelsList([])
    setCategoryList([])
    setDeckSizeList([])
    setDeckTypeList([])
    setStateAvailabilityList([])
    setProgramStatusList([])
    setAnnualHoursList([])
    setAutonomousList([])
    setsizeList([])
    setLengthList([])
    setSeatingCapacityList([])
    setEnclosedCabList([])
    setClassTypeList([])
    setGroupTypeList([])
    setVehicleClassList([])
    setGrossWeightList([])
    setCdlList([])
    setTrimList([])
    setUseList([])
    setCategory2List([])
    setCategoryTypeList([])
    setTypeList([])
  }



  const onChangeAssetType = (selectedOption: any) => {
    if (selectedOption.value !== selectedAssetType?.assetType?.value) {
      setSelectedAssetType((prev: any) => ({ ...prev, assetType: selectedOption, assetTypeError: '' }))
      setAddItemClicked(false)
      clearLocalStateDropdowns()
      dispatch(setAllDropdownBySubTypeId([]))
      setCatalogItemErrors({})
      setCatalogItemValues({})
      setShowKitAttributeTable(false)
    }
  }

  const onClickAddItemBtn = () => {
    if (selectedAssetType?.assetType?.value) {
      setAddItemClicked(true)
      dispatch(getAllDropdownBySubTypeId(selectedAssetType?.assetType?.id, selectedAssetType?.assetType?.value === CONSTANTS.VEHICLE));
      !vehicleTypeDropdown?.length && dispatch(getAssetType())
    } else {
      setSelectedAssetType((prev: any) => ({ ...prev, assetTypeError: 'Please select asset type' }))
    }
  }

  const onCancelClick = () => {
    handleClickBack()
  }

  const handleClickCancel = () => {
    setPopupcontentComplete({
      ...PopupcontentComplete,
      titleImg: ConfirmationBee,
      title: "CONFIRMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: 'If you leave this page, any changes you have made will be lost. Are you sure you wish to leave this page?',
      primaryBtnText: "Yes",
      outlineBtnText: "No",
      popupOutlinebtnOnclickComplete: () => {
        hideDialogComplete()
      },
      popupPrimarybtnOnclick: () => {
        hideDialogComplete();
        onCancelClick();
      },
      isSingleConfirmationBtn: false,
    })
  }

  const [PopupcontentComplete, setPopupcontentComplete] = useState<any>(popupInitialData);

  const hideDialogComplete = () => {
    setPopupcontentComplete({ ...PopupcontentComplete, isDialogVisible: false})
  };

  const getAssetModelAttributes = () => {
    let attributes = assetModelAttributes?.map((attribute: string) => {
      if (attribute === "classType") {
        return {
          attributeName: vehicleValuesKey.get("vehicleType"),
          attributeValueId: Number(catalogItemValues[attribute]?.value ?? 0)
        }
      }
      return {
        attributeName: vehicleValuesKey.get(attribute),
        attributeValueId: Number(catalogItemValues[attribute === "lengthAttr" ? "length" : attribute]?.value ?? 0)
      }
    }).filter((value: any) => (value?.attributeValueId != 0 && value?.attributeValueId != null && value?.attributeValueId != undefined && !Number.isNaN(value?.attributeValueId)))
    return attributes
  }

  const getEquipmentModelKitAttributes = () => {
    let attributes = kitAttributeValues?.map((attribute: any, index: number) => ({
      kitNumber: index + 1,
      kitDescription1: attribute.kitDescription1,
      kitDescription2: attribute.kitDescription2,
      quantity: Number(getOnlyNumbers(attribute.quantity)),
      unitPrice: Number(getOnlyNumbers(attribute.unitPrice))
    })
    )
    return attributes
  }

  const getPrice = () => {
    if (selectedAssetType?.assetType?.value === CONSTANTS.VEHICLE) {
      return parseFloat(getOnlyNumbers(catalogItemValues?.actualPrice || 0))
    } else {
      return parseFloat(getOnlyNumbers(catalogItemValues?.price || 0))
    }
  }

  const validateVehicle = () => {
    let vehicleRequiredFieldsTemp = [...vehicleRequiredFields]
    if(catalogItemValues?.vehicleType?.orderRequestType === CONSTANTS.PRODUCTION_VEHICLE){
      vehicleRequiredFieldsTemp.push('logoed')
      vehicleRequiredFieldsTemp.push('upfit')
      vehicleRequiredFieldsTemp.push('snowSetup')
    }else{
      vehicleRequiredFieldsTemp = vehicleRequiredFieldsTemp?.filter(item => item !== AttributeName.LOGOED);
    }
    let validateValues = vehicleRequiredFieldsTemp.map((name: any) => {
      if (catalogItemValues.nap && (name === 'actualPrice' || name === 'budgetingPercent' || name === 'budgetingPrice' || name === 'monthlyDeprecation')) {
        return true
      }
      if (catalogItemValues?.vehicleType?.orderRequestType === CONSTANTS.PRODUCTION_VEHICLE && name === 'vehicleLevel') {
        return true
      }
      return validateCatalogItemValues(catalogItemValues[name], name)
    })
    let validateKitValues = true;
    if (showKitAttributeTable && kitAttributeValues?.length) {
      validateKitValues = validateKitAttribute('Vehicle')
    }
    return validateValues.every((value: boolean) => value === true) && validateKitValues
  }

  const getRequiredFieldsEquipments = (assetType: string) => {
    if (assetType === CONSTANTS.MOWER) {
      return mowerRequiredFields
    } else if (assetType === CONSTANTS.TRAILER) {
      return trailerRequiredField
    } else if (assetType === CONSTANTS.UTILITY_VEHICLE) {
      return utilityVehicleRequiredField
    } else if (assetType === CONSTANTS.STANDARIZED_EQUIPMENT) {
      return standardizedEquipmentRequiredFields
    } else if (assetType === CONSTANTS.CONSTRUCTION_EQUIPMENT) {
      return constructionEquipmentRequiredFields
    } else if (assetType === CONSTANTS.SNOW) {
      return snowRequiredFields
    } else {
      return []
    }
  }

  const validateMower = (assetType: string) => {
    let validateKitValues = true;
    let requiredFieldsSet = getRequiredFieldsEquipments(assetType)
    let validateValues = requiredFieldsSet.map((name: any) => {
      if (catalogItemValues.nap && (name === 'actualPrice' || name === 'budgetingPercent' || name === 'budgetingPrice' || name === 'monthlyDeprecation')) {
        return true
      }

      if (name === 'category2' &&
        ((selectedAssetType?.assetType.value === CONSTANTS.CONSTRUCTION_EQUIPMENT && !CONSTRUCTION_EQUIPMENT_CATEGORY_WITH_CATEGORY_2.includes(catalogItemValues?.category?.label || '')) ||
        ( selectedAssetType.assetType.value === CONSTANTS.STANDARIZED_EQUIPMENT && !STANDARDIZED_EQUIPMENT_CATEGORY_WITH_CATEGORY_2.includes(catalogItemValues?.category?.label || '')))) {
        return true
      }

      if (name === 'categoryType' && 
        selectedAssetType?.assetType.value === CONSTANTS.SNOW && 
        !SNOW_CATEGORY_WITH_CATGORY_TYPE.includes(catalogItemValues?.category?.label || '')) {
        return true
      }

      return validateCatalogItemValues(catalogItemValues[name], name)
    })
    if (showKitAttributeTable && kitAttributeValues?.length) {
      validateKitValues = validateKitAttribute('Equipment')
    }
    let isValid = validateValues.every((value: boolean) => value === true) && validateKitValues
    return isValid
  }

  const validateKitAttribute = (catalogType?: any) => { 
    let kitValidations = kitAttributeValues?.map((kit: any) => {
      let values = Object.keys(kit)?.map((name: any) => {
        if (name === 'kitErrors') {
          return true
        }
        return validateAddedKitValues(kit[name], name, {}).isValid
      })
      return values
    })
    let totalPrice = getTotalKitPrice()
    let errorText = ''
    let catalogItemPrice = 0
    if(selectedAssetType?.assetType?.value === CONSTANTS.VEHICLE){
        catalogItemPrice = catalogItemValues?.actualPrice
        errorText = 'The Total Kit Price does not match the Actual Price'
    }
    else {
        catalogItemPrice = catalogItemValues?.price;
        errorText = 'The Total Kit Price does not match the Price'
    }
    if (parseFloat(getOnlyNumbers(catalogItemPrice)) != totalPrice) {
      setCatalogItemErrors((prev: any) => ({ ...prev, kitTotalError: errorText }))
    }
    if (!kitValidations.every((value: boolean[]) => value.every((kit: any) => kit === true))) {
      setCatalogItemErrors((prev: any) => ({ ...prev, kitError: 'Please provide all required kit values' }))
    }
    let priceVal = catalogType === 'Vehicle' ? catalogItemValues?.actualPrice : catalogItemValues?.price;
    const isValidFlag = kitValidations.every((value: boolean[]) => value.every((kit: any) => kit === true)) && (parseFloat(getOnlyNumbers(priceVal)) == totalPrice)
    return isValidFlag;
  }

  const isValidToSubmit = (assetType: string) => {
    switch (assetType) {
      case CONSTANTS.VEHICLE:
        return validateVehicle()
      case CONSTANTS.MOWER:
      case CONSTANTS.TRAILER:
      case CONSTANTS.UTILITY_VEHICLE:
      case CONSTANTS.STANDARIZED_EQUIPMENT:
      case CONSTANTS.CONSTRUCTION_EQUIPMENT:
      case CONSTANTS.SNOW:
        return validateMower(assetType)
      default:
        return false
    }
  }



  const getGLCode = (assetType: string) => {
    switch (assetType) {
      case CONSTANTS.VEHICLE:
        return catalogItemValues?.vehicleType?.value === 2 ? "2050" : "2055";
      case CONSTANTS.MOWER:
        return "2040";
      case CONSTANTS.SNOW:
        return "2056";
      case CONSTANTS.TRAILER:
        return "2045";
      case CONSTANTS.CONSTRUCTION_EQUIPMENT:
        return "2042";
      case CONSTANTS.STANDARIZED_EQUIPMENT:
        return "2042";
      case CONSTANTS.UTILITY_VEHICLE:
        return "2042";
      case CONSTANTS.TREE_CARE:
        return "2040";
      default:
        return ''
    }
  }

  const getOrderRequestSubTypeId = () => {
    if (selectedAssetType?.assetType?.value === CONSTANTS.VEHICLE) {
      return catalogItemValues?.vehicleType?.orderRequestSubTypeId
    } else {
      return selectedAssetType?.assetType?.id
    }
  }

  const handleClickAdd = () => {
    let isValid = isValidToSubmit(selectedAssetType?.assetType?.value)
    if (isValid) {
      let payload: any = {
        isNationalAccountPricing: catalogItemValues?.nap ? false : true,
        assetModelId: id ? (actionType == 'edit' ? catalogItemValues?.assetModelId : 0) : 0,
        orderRequestSubTypeId: getOrderRequestSubTypeId(),
        make: catalogItemValues?.make?.label || catalogItemValues?.manufacturer?.label,
        model: catalogItemValues?.model?.label ?? null,
        year: catalogItemValues?.year?.label,
        price: getPrice(),
        leadrDescription: catalogItemValues?.catalogDescription,
        detailedDescription: catalogItemValues?.detailedDescription,
        eOneDescription: catalogItemValues?.eOneDescription,
        bvSpecNo: catalogItemValues?.bvSpec,
        eqClassCodeId: Number(catalogItemValues?.eqClassCode?.value ?? 0) || null,
        poDescription1: catalogItemValues?.poDescription1,
        poDescription2: catalogItemValues?.poDescription2,
        vehicleLevel: catalogItemValues?.vehicleLevel?.map((level: any) => Number(level?.value ?? 0)),
        savedBy: userData?.emailId,
        status: catalogItemValues?.status?.value === "active",
        attachments: attachmentsList,
        assetModelAttributes: getAssetModelAttributes(),
        budgetInformation: {
          actualPrice: parseFloat(getOnlyNumbers(catalogItemValues?.actualPrice || 0)),
          budgetingPercent: parseInt(getOnlyNumbers(catalogItemValues?.budgetingPercent?.label || 0)),
          budgetingPrice: parseFloat(getOnlyNumbers(catalogItemValues?.budgetingPrice || 0)),
          usefulLifeOrLeaseTerm: catalogItemValues?.leaseTerm?.label,
          monthlyDepreciation: parseFloat(getOnlyNumbers(catalogItemValues?.monthlyDeprecation || 0)),
          glCode: getGLCode(selectedAssetType?.assetType?.value),
          logoed: catalogItemValues?.logoed?.label
        },
        equipmentModelKitAttributes: getEquipmentModelKitAttributes() || []
      }

      dispatch(saveCatalogItem(payload))
      dispatch(setIsCatalogItemSaved(undefined))
    } else {
      let decriptionTxt = (<p>Please provide all the required details to Save Catalog Item.</p>);
      setPopupcontentComplete({
        ...PopupcontentComplete,
        titleImg: ConfirmationBee,
        title: "Validation",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclickComplete: () => {
          hideDialogComplete()
        }
      });
    }
  }

  const handleOnChangeKitToggle = () => {
    if (showKitAttributeTable) {
      setShowKitAttributeTable(false)
      setCatalogItemErrors((prev: any) => ({ ...prev, kitTotalError: '' }))
    } else {
      if(selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE){
        if(catalogItemValues?.nap){
          setPopupcontentComplete({
            ...PopupcontentComplete,
            titleImg: ConfirmationBee,
            title: "INFORMATION",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: 'Please add Nation Accounting Price to add Kit Attributes',
            outlineBtnText: "Ok",
            isSingleConfirmationBtn: true,
            popupOutlinebtnOnclickComplete: () => {
              hideDialogComplete()
            }
          });
        }else
          setShowKitAttributeTable(true)
      }else
        setShowKitAttributeTable(true)
    }
    setKitAttributeValues([])
  }

  const handleNAPChange = (e: any, value: boolean) => {
    setCatalogItemValues((prev: any) => ({
      ...prev,
      nap: value,
      actualPrice: '',
      budgetingPercent: value ? '' : budgetPercentList[1],
      budgetingPrice: '',
      monthlyDeprecation: ''
    }))
    setCatalogItemErrors([{...catalogItemErrors,actualPrice: '',
    budgetingPercent: '',
    budgetingPrice: '',
    monthlyDeprecation: '' }])
    if(selectedAssetType?.assetType?.value === CONSTANTS.VEHICLE){
      setKitAttributeValues([])
      setShowKitAttributeTable(false)
      setCatalogItemErrors((prev: any) => ({ ...prev, kitTotalError: '' }))
    }
  }

  const onChangeStatus = (value: any) => {
    setCatalogItemValues((prev: any) => ({ ...prev, status: value }))
    validateCatalogItemValues(value, 'status')
  }

  const nameMap: Record<string, string> = {
    "manufacturer": "make",
    "length": "lengthAttr"
  };

  const validateCatalogItemValues = (value: any, name: any) => {
    let isValid = true
    if (name in nameMap) {
      name = nameMap[name];
    }
    let displayValue = vehicleValuesKey.get(name) == AttributeName.VEHICLE_LEVEL ? AttributeName.ASSIGNMENT_GROUPS : vehicleValuesKey.get(name);
    if (Array.isArray(value)) {
      if (value?.length == 0) {
        setCatalogItemErrors((prev: any) => ({ ...prev, [name]: `Please select ${displayValue}` }))
        isValid = false
      } else {
        setCatalogItemErrors((prev: any) => ({ ...prev, [name]: '' }))
      }
    } else if (typeof value === 'object') {
      if (!value?.value) {
        setCatalogItemErrors((prev: any) => ({ ...prev, [name]: `Please provide ${displayValue}` }))
        isValid = false
      } else {
        setCatalogItemErrors((prev: any) => ({ ...prev, [name]: '' }))
      }
    } else if (name === 'actualPrice' || name === 'budgetingPrice' || name === 'price') {
      if (!value || value == 0) {
        setCatalogItemErrors((prev: any) => ({ ...prev, [name]: `Please provide ${displayValue}` }))
        isValid = false
      } else {
        setCatalogItemErrors((prev: any) => ({ ...prev, [name]: '' }))
      }
    } else {
      if (!value && name != 'nap') {
        setCatalogItemErrors((prev: any) => ({ ...prev, [name]: `Please provide ${displayValue}` }))
        isValid = false
      } else if (value?.length > 30 && name === 'eOneDescription') {
        setCatalogItemErrors((prev: any) => ({ ...prev, [name]: `Please provide ${displayValue} in less than 30 characters` }))
        isValid = false
      } else if (value?.length > 200 && name === 'catalogDescription') {
        setCatalogItemErrors((prev: any) => ({ ...prev, [name]: `Please provide ${displayValue} in less than 200 characters` }))
        isValid = false
      } else if (value?.length > 30 && (name === 'poDescription1' || name === 'poDescription2')) {
        setCatalogItemErrors((prev: any) => ({ ...prev, [name]: `Please provide ${displayValue} in less than 30 characters` }))
        isValid = false
      } else if (value?.length > 100 && name === 'detailedDescription') {
        setCatalogItemErrors((prev: any) => ({ ...prev, [name]: `Please provide ${displayValue} in less than 100 characters` }))
        isValid = false
      } else {
        setCatalogItemErrors((prev: any) => ({ ...prev, [name]: '' }))
      }
    }
    return isValid
  }

  const isUploaded = (name: string) => attachmentsList.find((x: any) => getFileName(x.attachmentUrl) === name);

  const onUploadClick = (fileList: Array<File>) => {
    let listItem = {
      fileList: fileList,
      uploadedList: attachmentsList,
    }
    commononUploadClick(listItem, setError, isUploaded, dispatch, uploadAttachments, null, false);
    setError("");
    const filteredList = [
      ...fileList.filter((x) => !isUploaded(x.name || (x as any).fileName)),
    ];
    if (filteredList.length > 0 && filteredList.length <= 5) {
      setError("");
      let totalSize = 0;
      filteredList.forEach((file: File) => {
        totalSize = totalSize + (file.size || 0);
      });
      if (totalSize <= 5000000) {
        setError("");
        const formData = new FormData();
        formData.append("ContainerFolderName", "Order_Request_Attachments/" + uuid());

        for (const element of filteredList) {
          formData.append("Files", element as any);
        }
        dispatchUploadAttachments({ formData, filteredList, list: attachmentsList });
      } else {
        setError("Please Upload files without exceeding maximum size of 5MB");
      }
    } else if (fileList.length > 5) {
      setError(
        "Please Upload files without exceeding maximum limit of 5 files"
      );
    } else {
      if (fileList.length > 0 && !filteredList.length) {
        setError("All files are uploaded try to add new files");
      } else {
        setError("Choose at least 1 file to upload");
      }
    }
  };

  const onRemoveAttachment = (index: number) => {
    const newArr = attachmentsList.slice();
    newArr.splice(index, 1);
    const newFileList = [...list];
    newFileList.splice(index, 1);
    setList(newFileList);
    dispatchRemoveAttachment(newArr);
    setError("");
  }

  const getTotalKitPrice = () => {
    let total: any = kitAttributeValues?.reduce((acc: number, kit: any) => {
      acc += Number(getOnlyNumbers(kit.unitPrice)) * kit.quantity
      return acc
    }, 0)
    total = total.toFixed(2)
    return total
  }

  const validateAddedKitValues = (value: any, name: any, errors: any) => {
    let isValid = true
    setCatalogItemErrors((prev: any) => ({ ...prev, kitTotalError: '', kitError: '' }))
    if (!value) {
      isValid = false
      errors[name] = `Please provide ${kitValuesKey.get(name)}`
    } else if (value.length > 100 && (name === 'kitDescription1' || name === 'kitDescription2')) {
      isValid = false
      errors[name] = `Please provide ${kitValuesKey.get(name)} in less than 100 characters`
    } else if (name === 'unitPrice' && Number(value) > 9999999999) {
      isValid = false
      errors[name] = `Please provide valid ${kitValuesKey.get(name)}`
    } else {
      errors[name] = ''
    }
    return { isValid, errors }
  }

  const getRequestTypeForEditScreen = (subTypeId: number) => {
    switch (subTypeId) {
      case 1:
        return CONSTANTS.MANAGEMENT_VEHICLE
      case 2:
        return CONSTANTS.PRODUCTION_VEHICLE
      case 3:
        return CONSTANTS.MOWER
      case 4:
        return CONSTANTS.UTILITY_VEHICLE
      case 5:
        return CONSTANTS.TRAILER
      case 6:
        return CONSTANTS.SNOW
      case 7:
        return CONSTANTS.CONSTRUCTION_EQUIPMENT
      case 8:
        return CONSTANTS.TREE_CARE
      case 9:
        return CONSTANTS.STANDARIZED_EQUIPMENT
      default:
        return ""
    }
  }

  useEffect(() => {
    if (catalogUpdateNoOfDoors && !isCatalogUpdateNoOfDoorSaved && !isCatalogNoOfDoorRemoved) {
      setExisitingDropDownValue(catalogUpdateNoOfDoors)
    } else if (catalogUpdateNoOfDoors && (isCatalogUpdateNoOfDoorSaved || isCatalogNoOfDoorRemoved)) {
      const defaultDoors = {
        text: "Select No. of Doors",
        value: null
      };
      let catalogUpdateNoOfDoorsTemp = catalogUpdateNoOfDoors ? JSON.parse(JSON.stringify(catalogUpdateNoOfDoors)) : []
      catalogUpdateNoOfDoorsTemp?.unshift(defaultDoors);
      let options = catalogUpdateNoOfDoorsTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setNoOfDoorsList(options)
      dispatch(setCatalogUpdateNoOfDoorSave(null))
      dispatch(setCatalogRemoveNoOfDoor(null))
    }

    if (catalogUpdateNoOfDoors && isCatalogNoOfDoorRemoved && isCatalogNoOfDoorRemoved != null) {
      setExisitingDropDownValue(catalogUpdateNoOfDoors)
      if (!id) {
        let isDeletedValueSelected = catalogUpdateNoOfDoors?.filter((item?: any) => item?.text == catalogItemValues?.noOfDoors?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            noOfDoors: '',
          }))
        }
      }
    }
  }, [catalogUpdateNoOfDoors])

  useEffect(() => {
    if (catalogUpdateYear && !isCatalogUpdateYearSaved && !isCatalogYearRemoved) {
      setExisitingDropDownValue(catalogUpdateYear)
    } else if (catalogUpdateYear && (isCatalogUpdateYearSaved || isCatalogYearRemoved)) {
      const defaultYear = {
        text: "Select Year",
        value: null
      };
      let catalogUpdateYearTemp = catalogUpdateYear ? JSON.parse(JSON.stringify(catalogUpdateYear)) : []
      catalogUpdateYearTemp?.unshift(defaultYear);
      let options = catalogUpdateYearTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setYearList(options)
      dispatch(setCatalogUpdateYearSave(null))
      dispatch(setCatalogRemoveYear(null))
    }

    if (catalogUpdateYear && isCatalogYearRemoved && isCatalogYearRemoved != null) {
      setExisitingDropDownValue(catalogUpdateYear)
      if (!id) {
        let isDeletedValueSelected = catalogUpdateYear?.filter((item?: any) => item?.text == catalogItemValues?.year?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            year: '',
          }))
        }
      }
    }
  }, [catalogUpdateYear])

  useEffect(() => {
    if (catalogUpdateVehicleClass && !isCatalogUpdateVehicleClassSaved && !isCatalogVehicleClassRemoved) {
      setExisitingDropDownValue(catalogUpdateVehicleClass)
    } else if (catalogUpdateVehicleClass && (isCatalogUpdateVehicleClassSaved || isCatalogVehicleClassRemoved)) {
      const defaultVehicleClass = {
        text: "Select Vehicle Class",
        value: null
      };
      let catalogUpdateVehicleClassTemp = catalogUpdateVehicleClass ? JSON.parse(JSON.stringify(catalogUpdateVehicleClass)) : []
      catalogUpdateVehicleClassTemp?.unshift(defaultVehicleClass);
      let options = catalogUpdateVehicleClassTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setVehicleClassList(options)
      dispatch(setCatalogUpdateVehicleClassSave(null))
      dispatch(setCatalogRemoveVehicleClass(null))
    }

    if (catalogUpdateVehicleClass && isCatalogVehicleClassRemoved && isCatalogVehicleClassRemoved != null) {
      setExisitingDropDownValue(catalogUpdateVehicleClass)
      if (!id) {
        let isDeletedValueSelected = catalogUpdateVehicleClass?.filter((item?: any) => item?.text == catalogItemValues?.year?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            vehicleClass: '',
          }))
        }
      }
    }
  }, [catalogUpdateVehicleClass])

  useEffect(() => {
    if (catalogUpdateGroupType && !isCatalogUpdateGroupTypeSaved && !isCatalogGroupTypeRemoved) {
      setExisitingDropDownValue(catalogUpdateGroupType)
    } else if (catalogUpdateGroupType && (isCatalogUpdateGroupTypeSaved || isCatalogGroupTypeRemoved)) {
      const defaultGroupType = {
        text: "Select Group Type",
        value: null
      };
      let catalogUpdateGroupTypeTemp = catalogUpdateGroupType ? JSON.parse(JSON.stringify(catalogUpdateGroupType)) : []
      catalogUpdateGroupTypeTemp?.unshift(defaultGroupType);
      let options = catalogUpdateGroupTypeTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setGroupTypeList(options)
      dispatch(setCatalogUpdateGroupTypeSave(null))
      dispatch(setCatalogRemoveGroupType(null))
    }

    if (catalogUpdateGroupType && isCatalogGroupTypeRemoved && isCatalogGroupTypeRemoved != null) {
      setExisitingDropDownValue(catalogUpdateGroupType)
      if (!id) {
        let isDeletedValueSelected = catalogUpdateGroupType?.filter((item?: any) => item?.text == catalogItemValues?.year?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            groupType: '',
          }))
        }
      }
    }
  }, [catalogUpdateGroupType])

  useEffect(() => {
    if (catalogUpdateGrossWeight && !isCatalogUpdateGrossWeightSaved && !isCatalogGrossWeightRemoved) {
      setExisitingDropDownValue(catalogUpdateGrossWeight)
    } else if (catalogUpdateGrossWeight && (isCatalogUpdateGrossWeightSaved || isCatalogGrossWeightRemoved)) {
      const defaultGrossWeight = {
        text: "Select Gross Vehicle Weight Rating",
        value: null
      };
      let catalogUpdateGrossWeightTemp = catalogUpdateGrossWeight ? JSON.parse(JSON.stringify(catalogUpdateGrossWeight)) : []
      catalogUpdateGrossWeightTemp?.unshift(defaultGrossWeight);
      let options = catalogUpdateGrossWeightTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setGrossWeightList(options)
      dispatch(setCatalogUpdateGrossWeightSave(null))
      dispatch(setCatalogRemoveGrossWeight(null))
    }

    if (catalogUpdateGrossWeight && isCatalogGrossWeightRemoved && isCatalogGrossWeightRemoved != null) {
      setExisitingDropDownValue(catalogUpdateGrossWeight)
      if (!id) {
        let isDeletedValueSelected = catalogUpdateGrossWeight?.filter((item?: any) => item?.text == catalogItemValues?.year?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            vehicleGrossWeightRating: '',
          }))
        }
      }
    }
  }, [catalogUpdateGrossWeight])

  useEffect(() => {
    if (catalogUpdateTrim && !isCatalogUpdateTrimSaved && !isCatalogTrimRemoved) {
      setExisitingDropDownValue(catalogUpdateTrim)
    } else if (catalogUpdateTrim && (isCatalogUpdateTrimSaved || isCatalogTrimRemoved)) {
      const defaultTrim = {
        text: "Select Trim",
        value: null
      };
      let catalogUpdateTrimTemp = catalogUpdateTrim ? JSON.parse(JSON.stringify(catalogUpdateTrim)) : []
      catalogUpdateTrimTemp?.unshift(defaultTrim);
      let options = catalogUpdateTrimTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setTrimList(options)
      dispatch(setCatalogUpdateTrimSave(null))
      dispatch(setCatalogRemoveTrim(null))
    }

    if (catalogUpdateTrim && isCatalogTrimRemoved && isCatalogTrimRemoved != null) {
      setExisitingDropDownValue(catalogUpdateTrim)
      if (!id) {
        let isDeletedValueSelected = catalogUpdateTrim?.filter((item?: any) => item?.text == catalogItemValues?.year?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            trim: '',
          }))
        }
      }
    }
  }, [catalogUpdateTrim])

  useEffect(() => {
    if (catalogUpdateClassType && !isCatalogUpdateClassTypeSaved && !isCatalogClassTypeRemoved) {
      setExisitingDropDownValue(catalogUpdateClassType)
    } else if (catalogUpdateClassType && (isCatalogUpdateClassTypeSaved || isCatalogClassTypeRemoved)) {
      const defaultClassType = {
        text: "Select Class Type",
        value: null
      };
      let catalogUpdateClassTypeTemp = catalogUpdateClassType ? JSON.parse(JSON.stringify(catalogUpdateClassType)) : []
      catalogUpdateClassTypeTemp?.unshift(defaultClassType);
      let options = catalogUpdateClassTypeTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value, showVehicleCapacity: val.selected })
      );
      setClassTypeList(options)
      dispatch(setCatalogUpdateClassTypeSave(null))
      dispatch(setCatalogRemoveClassType(null))
    }

    if (catalogUpdateClassType && isCatalogClassTypeRemoved && isCatalogClassTypeRemoved != null) {
      setExisitingDropDownValue(catalogUpdateClassType)
      if (!id) {
        let isDeletedValueSelected = catalogUpdateClassType?.filter((item?: any) => item?.text == catalogItemValues?.year?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            classType: '',
          }))
        }
      }
    }
  }, [catalogUpdateClassType])

  useEffect(() => {
    if (catalogUpdateCapacity && !isVehicleCapacityEdited && !isCatalogUpdateCapacitySaved && !isCatalogCapacityRemoved) {
      setExisitingDropDownValue(catalogUpdateCapacity)
    } else if (catalogUpdateCapacity && (isCatalogUpdateCapacitySaved || isCatalogCapacityRemoved || isVehicleCapacityEdited)) {
      const defaultAutonomous = {
        text: "Select Capacity",
        value: null
      };
      let catalogUpdateCapacityTemp = catalogUpdateCapacity ? JSON.parse(JSON.stringify(catalogUpdateCapacity)) : []
      catalogUpdateCapacityTemp?.unshift(defaultAutonomous);
      let options = catalogUpdateCapacityTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setCapacityList(options)
      dispatch(setCatalogUpdateCapacitySave(null))
      dispatch(setCatalogRemoveCapacity(null))
      dispatch(setEditCatalogVehicleCapacity(null))
    }
    if(catalogUpdateCapacity && isVehicleCapacityEdited && isVehicleCapacityEdited != null){
      if (selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE) {
        
      let changeSelelctedVal = catalogUpdateCapacity?.find((item?: any) => item?.value == catalogItemValues?.truckSize?.value)
      setCatalogItemValues((prev: any) => ({
        ...prev,
        truckSize: { value: changeSelelctedVal?.value, label: changeSelelctedVal?.text, key: changeSelelctedVal?.value }
      }))
    }
    }
    if (catalogUpdateCapacity && isCatalogCapacityRemoved && isCatalogCapacityRemoved != null) {
      setExisitingDropDownValue(catalogUpdateCapacity)
      if (!id) {
        let isDeletedValueSelected = []
        if (selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE) {
          isDeletedValueSelected = catalogUpdateCapacity?.filter((item?: any) => item?.text == catalogItemValues?.truckSize?.label)
        } else {
          isDeletedValueSelected = catalogUpdateCapacity?.filter((item?: any) => item?.text == catalogItemValues?.capacity?.label)
        }
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            capacity: '',
            truckSize: ''
          }))
        }
      }
    }
  }, [catalogUpdateCapacity])

  useEffect(() => {
    let options: any = []
    if (catalogUpdateUpfit && !isCatalogUpdateUpfitSaved && !isCatalogUpfitRemoved) {
      setExisitingDropDownValue(catalogUpdateUpfit)
    } else if (catalogUpdateUpfit && (isCatalogUpdateUpfitSaved || isCatalogUpfitRemoved)) {
      const defaultUpfitOption = {
        text: "Select Upfit Option",
        value: null
      };
      let catalogUpdateUpfitTemp = catalogUpdateUpfit ? JSON.parse(JSON.stringify(catalogUpdateUpfit)) : []
      catalogUpdateUpfitTemp?.unshift(defaultUpfitOption);
      options = catalogUpdateUpfitTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setUpfitOptionList(options)
      dispatch(setCatalogUpdateUpfitSave(null))
      dispatch(setCatalogRemoveUpfit(null))
    }

    if (catalogUpdateUpfit && isCatalogUpfitRemoved && isCatalogUpfitRemoved != null) {
      setExisitingDropDownValue(catalogUpdateUpfit)
      if (!id) {
        let isDeletedValueSelected = catalogUpdateUpfit?.filter((item?: any) => item?.text == catalogItemValues?.upfit?.label)
        if (isDeletedValueSelected?.length == 0 && catalogItemValues?.vehicleType?.label != "Management Vehicle") {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            upfit: '',
          }))
        }
      }
    }
  }, [catalogUpdateUpfit])

  useEffect(() => {
    if (catalogUpdateDriveTrain && !isCatalogUpdateDriveTrainSaved && !isCatalogDriveTrainRemoved) {
      setExisitingDropDownValue(catalogUpdateDriveTrain)
    } else if (catalogUpdateDriveTrain && (isCatalogUpdateDriveTrainSaved || isCatalogDriveTrainRemoved)) {
      const defaultDriveTrain = {
        text: "Select Drive Train",
        value: null
      };
      let catalogUpdateDriveTrainTemp = catalogUpdateDriveTrain ? JSON.parse(JSON.stringify(catalogUpdateDriveTrain)) : []
      catalogUpdateDriveTrainTemp?.unshift(defaultDriveTrain);
      let options = catalogUpdateDriveTrainTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setDriveTrainList(options)
      dispatch(setCatalogUpdateDriveTrainSave(null))
      dispatch(setCatalogRemoveDriveTrain(null))
    }

    if (catalogUpdateDriveTrain && isCatalogDriveTrainRemoved && isCatalogDriveTrainRemoved != null) {
      setExisitingDropDownValue(catalogUpdateDriveTrain)
      if (!id) {
        let isDeletedValueSelected = catalogUpdateDriveTrain?.filter((item?: any) => item?.text == catalogItemValues?.driveTrain?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            driveTrain: '',
          }))
        }
      }
    }
  }, [catalogUpdateDriveTrain])

  useEffect(() => {
    if (catalogUpdatePowerType && !isCatalogUpdatePowerTypeSaved && !isCatalogPowerTypeRemoved) {
      setExisitingDropDownValue(catalogUpdatePowerType)
    } else if (catalogUpdatePowerType && (isCatalogUpdatePowerTypeSaved || isCatalogPowerTypeRemoved)) {
      const defaultPowerType = {
        text: "Select Power Type",
        value: null
      };
      let catalogUpdatePowerTypeTemp = catalogUpdatePowerType ? JSON.parse(JSON.stringify(catalogUpdatePowerType)) : []
      catalogUpdatePowerTypeTemp?.unshift(defaultPowerType);
      let options = catalogUpdatePowerTypeTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setPowerTypeList(options)
      dispatch(setCatalogUpdatePowerTypeSave(null))
      dispatch(setCatalogRemovePowerType(null))
    }

    if (catalogUpdatePowerType && isCatalogPowerTypeRemoved && isCatalogPowerTypeRemoved != null) {
      setExisitingDropDownValue(catalogUpdatePowerType)
      if (!id) {
        let isDeletedValueSelected = catalogUpdatePowerType?.filter((item?: any) => item?.text == catalogItemValues?.fuelType?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            fuelType: '',
          }))
        }
      }
    }
  }, [catalogUpdatePowerType])

  useEffect(() => {
    if (catalogUpdateVehicleLevel && !isCatalogUpdateVehicleLevelSaved && !isCatalogVehicleLevelRemoved) {
      setExisitingDropDownValue(catalogUpdateVehicleLevel)
    } else if (catalogUpdateVehicleLevel && (isCatalogUpdateVehicleLevelSaved || isCatalogVehicleLevelRemoved)) {
      let catalogUpdateVehicleLevelTemp = catalogUpdateVehicleLevel ? JSON.parse(JSON.stringify(catalogUpdateVehicleLevel)) : []
      let options = catalogUpdateVehicleLevelTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setVehicleLevelList(options)
      dispatch(setCatalogUpdateVehicleLevelSave(null))
      dispatch(setCatalogRemoveVehicleLevel(null))
    }

    if (catalogUpdateVehicleLevel && isCatalogVehicleLevelRemoved && isCatalogVehicleLevelRemoved != null) {
      setExisitingDropDownValue(catalogUpdateVehicleLevel)
      if (!id) {
        let isDeletedValueSelected = catalogUpdateVehicleLevel?.filter((item?: any) => item?.text == catalogItemValues?.vehicleLevel?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            vehicleLevel: '',
          }))
        }
      }
    }
  }, [catalogUpdateVehicleLevel])

  useEffect(() => {
    if (catalogUpdateEqClassCode && !isCatalogUpdateEqClassCodeSaved && !isCatalogEqClassCodeRemoved) {
      setExisitingDropDownValue(catalogUpdateEqClassCode)
    } else if (catalogUpdateEqClassCode && (isCatalogUpdateEqClassCodeSaved || isCatalogEqClassCodeRemoved)) {
      const defaultEqClassCode = {
        text: "Select Eq Class Code",
        value: null
      };
      let catalogUpdateEqClassCodeTemp = catalogUpdateEqClassCode ? JSON.parse(JSON.stringify(catalogUpdateEqClassCode)) : []
      catalogUpdateEqClassCodeTemp?.unshift(defaultEqClassCode);
      let options = catalogUpdateEqClassCodeTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setEqClassCodeList(options)
      dispatch(setCatalogUpdateEqClassCodeSave(null))
      dispatch(setCatalogRemoveEqClassCode(null))
    }

    if (catalogUpdateEqClassCode && isCatalogEqClassCodeRemoved && isCatalogEqClassCodeRemoved != null) {
      setExisitingDropDownValue(catalogUpdateEqClassCode)
      if (!id) {
        let isDeletedValueSelected = catalogUpdateEqClassCode?.filter((item?: any) => item?.text == catalogItemValues?.eqClassCode?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            eqClassCode: '',
          }))
        }
      }
    }
  }, [catalogUpdateEqClassCode])

  useEffect(() => {
    if (filterName == 'Make' || filterName == "Manufacturer") {
      if (catalogUpdateMake && !isCatalogUpdateMakeSaved && !isCatalogMakeRemoved) {
        setExisitingDropDownValue(catalogUpdateMake)
      } else if (catalogUpdateMake && (isCatalogUpdateMakeSaved || isCatalogMakeRemoved)) {
        const defaultMake = {
          text: "Select Make",
          value: null
        };
        let catalogUpdateMakeTemp = catalogUpdateMake ? JSON.parse(JSON.stringify(catalogUpdateMake)) : []
        catalogUpdateMakeTemp?.unshift(defaultMake);
        let options = catalogUpdateMakeTemp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setMakeList(options)
        dispatch(setCatalogUpdateMakeSave(null))
        dispatch(setCatalogRemoveMake(null))
      }

      if (catalogUpdateMake && isCatalogMakeRemoved && isCatalogMakeRemoved != null) {
        setExisitingDropDownValue(catalogUpdateMake)
        if (!id) {
          let isDeletedValueSelected = []
          if (selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE) {
            isDeletedValueSelected = catalogUpdateMake?.filter((item?: any) => item?.text == catalogItemValues?.make?.label)
          } else {
            isDeletedValueSelected = catalogUpdateModel?.filter((item?: any) => item?.text == catalogItemValues?.manufacturer?.label)
          }
          if (isDeletedValueSelected?.length == 0) {
            setModelsList([])
            setCatalogItemValues((prev: any) => ({
              ...prev,
              make: '',
              manufacturer: '',
              model: ''
            }))
          }
        }
      }
    }
  }, [catalogUpdateMake])

  useEffect(() => {
    if (filterName == 'State Availability') {
      if (catalogUpdateStateAvailability && !isCatalogUpdateStateAvailabilitySaved && !isCatalogStateAvailabilityRemoved) {
        setExisitingDropDownValue(catalogUpdateStateAvailability)
      } else if (catalogUpdateStateAvailability && (isCatalogUpdateStateAvailabilitySaved || isCatalogStateAvailabilityRemoved)) {
        const defaultStateAvailability = {
          text: "Select State Availability",
          value: null
        };
        let catalogUpdateStateAvailabilityTemp = catalogUpdateStateAvailability ? JSON.parse(JSON.stringify(catalogUpdateStateAvailability)) : []
        catalogUpdateStateAvailabilityTemp?.unshift(defaultStateAvailability);
        let options = catalogUpdateStateAvailabilityTemp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setStateAvailabilityList(options)
        dispatch(setCatalogUpdateStateAvailabilitySave(null))
        dispatch(setCatalogRemoveStateAvailability(null))
      }

      if (catalogUpdateStateAvailability && isCatalogStateAvailabilityRemoved && isCatalogStateAvailabilityRemoved != null) {
        setExisitingDropDownValue(catalogUpdateStateAvailability)
        if (!id) {
          let isDeletedValueSelected = catalogUpdateStateAvailability?.filter((item?: any) => item?.text == catalogItemValues?.stateAvailability?.label)
          if (isDeletedValueSelected?.length == 0) {
            setCatalogItemValues((prev: any) => ({
              ...prev,
              stateAvailability: '',
            }))
          }
        }
      }
    }
  }, [catalogUpdateStateAvailability])

  useEffect(() => {
    if (filterName == 'Program Status') {
      if (catalogUpdateProgramStatus && !isCatalogUpdateProgramStatusSaved && !isCatalogProgramStatusRemoved) {
        setExisitingDropDownValue(catalogUpdateProgramStatus)
      } else if (catalogUpdateProgramStatus && (isCatalogUpdateProgramStatusSaved || isCatalogProgramStatusRemoved)) {
        const defaultProgramStatus = {
          text: "Select Program Status",
          value: null
        };
        let catalogUpdateProgramStatusTemp = catalogUpdateProgramStatus ? JSON.parse(JSON.stringify(catalogUpdateProgramStatus)) : []
        catalogUpdateProgramStatusTemp?.unshift(defaultProgramStatus);
        let options = catalogUpdateProgramStatusTemp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setProgramStatusList(options)
        dispatch(setCatalogUpdateProgramStatusSave(null))
        dispatch(setCatalogRemoveProgramStatus(null))
      }

      if (catalogUpdateProgramStatus && isCatalogProgramStatusRemoved && isCatalogProgramStatusRemoved != null) {
        setExisitingDropDownValue(catalogUpdateProgramStatus)
        if (!id) {
          let isDeletedValueSelected = catalogUpdateProgramStatus?.filter((item?: any) => item?.text == catalogItemValues?.programStatus?.label)
          if (isDeletedValueSelected?.length == 0) {
            setCatalogItemValues((prev: any) => ({
              ...prev,
              programStatus: '',
            }))
          }
        }
      }
    }
  }, [catalogUpdateProgramStatus])

  useEffect(() => {
    if (filterName == 'Annual Hours') {
      if (catalogUpdateAnnualHours && !isCatalogUpdateAnnualHoursSaved && !isCatalogAnnualHoursRemoved) {
        setExisitingDropDownValue(catalogUpdateAnnualHours)
      } else if (catalogUpdateAnnualHours && (isCatalogUpdateAnnualHoursSaved || isCatalogAnnualHoursRemoved)) {
        const defaultAnnualHours = {
          text: "Select Annual Hours",
          value: null
        };
        let catalogUpdateAnnualHoursTemp = catalogUpdateAnnualHours ? JSON.parse(JSON.stringify(catalogUpdateAnnualHours)) : []
        catalogUpdateAnnualHoursTemp?.unshift(defaultAnnualHours);
        let options = catalogUpdateAnnualHoursTemp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setAnnualHoursList(options)
        dispatch(setCatalogUpdateAnnualHoursSave(null))
        dispatch(setCatalogRemoveAnnualHours(null))
      }

      if (catalogUpdateAnnualHours && isCatalogAnnualHoursRemoved && isCatalogAnnualHoursRemoved != null) {
        setExisitingDropDownValue(catalogUpdateAnnualHours)
        if (!id) {
          let isDeletedValueSelected = catalogUpdateAnnualHours?.filter((item?: any) => item?.text == catalogItemValues?.annualHours?.label)
          if (isDeletedValueSelected?.length == 0) {
            setCatalogItemValues((prev: any) => ({
              ...prev,
              annualHours: '',
            }))
          }
        }
      }
    }
  }, [catalogUpdateAnnualHours])

  useEffect(() => {
    if (filterName == 'Deck Size') {
      if (catalogUpdateDeckSize && !isCatalogUpdateDeckSizeSaved && !isCatalogDeckSizeRemoved) {
        setExisitingDropDownValue(catalogUpdateDeckSize)
      } else if (catalogUpdateDeckSize && (isCatalogUpdateDeckSizeSaved || isCatalogDeckSizeRemoved)) {
        const defaultDeckSize = {
          text: "Select Deck Size",
          value: null
        };
        let catalogUpdateDeckSizeTemp = catalogUpdateDeckSize ? JSON.parse(JSON.stringify(catalogUpdateDeckSize)) : []
        catalogUpdateDeckSizeTemp?.unshift(defaultDeckSize);
        let options = catalogUpdateDeckSizeTemp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setDeckSizeList(options)
        dispatch(setCatalogUpdateDeckSizeSave(null))
        dispatch(setCatalogRemoveDeckSize(null))
      }

      if (catalogUpdateDeckSize && isCatalogDeckSizeRemoved && isCatalogDeckSizeRemoved != null) {
        setExisitingDropDownValue(catalogUpdateDeckSize)
        if (!id) {
          let isDeletedValueSelected = catalogUpdateDeckSize?.filter((item?: any) => item?.text == catalogItemValues?.deckSize?.label)
          if (isDeletedValueSelected?.length == 0) {
            setCatalogItemValues((prev: any) => ({
              ...prev,
              deckSize: '',
            }))
          }
        }
      }
    }
  }, [catalogUpdateDeckSize])

  useEffect(() => {
    if (filterName == 'Deck Type') {
      if (catalogUpdateDeckType && !isCatalogUpdateDeckTypeSaved && !isCatalogDeckTypeRemoved) {
        setExisitingDropDownValue(catalogUpdateDeckType)
      } else if (catalogUpdateDeckType && (isCatalogUpdateDeckTypeSaved || isCatalogDeckTypeRemoved)) {
        const defaultDeckType = {
          text: "Select Deck Type",
          value: null
        };
        let catalogUpdateDeckTypeTemp = catalogUpdateDeckType ? JSON.parse(JSON.stringify(catalogUpdateDeckType)) : []
        catalogUpdateDeckTypeTemp?.unshift(defaultDeckType);
        let options = catalogUpdateDeckTypeTemp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setDeckTypeList(options)
        dispatch(setCatalogUpdateDeckTypeSave(null))
        dispatch(setCatalogRemoveDeckType(null))
      }

      if (catalogUpdateDeckType && isCatalogDeckTypeRemoved && isCatalogDeckTypeRemoved != null) {
        setExisitingDropDownValue(catalogUpdateDeckType)
        if (!id) {
          let isDeletedValueSelected = catalogUpdateDeckSize?.filter((item?: any) => item?.text == catalogItemValues?.deckType?.label)
          if (isDeletedValueSelected?.length == 0) {
            setCatalogItemValues((prev: any) => ({
              ...prev,
              deckType: '',
            }))
          }
        }
      }
    }
  }, [catalogUpdateDeckType])

  useEffect(() => {
    if (filterName == 'Size') {
      if (catalogUpdateSize && !isCatalogUpdateSizeSaved && !isCatalogSizeRemoved) {
        setExisitingDropDownValue(catalogUpdateSize)
      } else if (catalogUpdateSize && (isCatalogUpdateSizeSaved || isCatalogSizeRemoved)) {
        const defaultSize = {
          text: "Select Size",
          value: null
        };
        let catalogUpdateSizeTemp = catalogUpdateSize ? JSON.parse(JSON.stringify(catalogUpdateSize)) : []
        catalogUpdateSizeTemp?.unshift(defaultSize);
        let options = catalogUpdateSizeTemp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setsizeList(options)
        dispatch(setCatalogUpdateSizeSave(null))
        dispatch(setCatalogRemoveSize(null))
      }

      if (catalogUpdateSize && isCatalogSizeRemoved && isCatalogSizeRemoved != null) {
        setExisitingDropDownValue(catalogUpdateSize)
        if (!id) {
          let isDeletedValueSelected = catalogUpdateSize?.filter((item?: any) => item?.text == catalogItemValues?.size?.label)
          if (isDeletedValueSelected?.length == 0) {
            setCatalogItemValues((prev: any) => ({
              ...prev,
              size: '',
            }))
          }
        }
      }
    }
  }, [catalogUpdateSize])

  useEffect(() => {
    if (filterName == 'Type') {
      if (catalogUpdateType && !isCatalogUpdateTypeSaved && !isCatalogTypeRemoved) {
        setExisitingDropDownValue(catalogUpdateType)
      } else if (catalogUpdateType && (isCatalogUpdateTypeSaved || isCatalogTypeRemoved)) {
        const defaultSize = {
          text: "Select ",
          value: null
        };
        let catalogUpdateTypeTemp = catalogUpdateType ? JSON.parse(JSON.stringify(catalogUpdateType)) : []
        catalogUpdateTypeTemp?.unshift(defaultSize);
        let options = catalogUpdateTypeTemp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setTypeList(options)
        dispatch(setCatalogUpdateTypeSave(null))
        dispatch(setCatalogRemoveType(null))
      }

      if (catalogUpdateType && isCatalogTypeRemoved && isCatalogTypeRemoved != null) {
        setExisitingDropDownValue(catalogUpdateType)
        if (!id) {
          let isDeletedValueSelected = catalogUpdateType?.filter((item?: any) => item?.text == catalogItemValues?.type?.label)
          if (isDeletedValueSelected?.length == 0) {
            setCatalogItemValues((prev: any) => ({
              ...prev,
              type: '',
            }))
          }
        }
      }
    }
  }, [catalogUpdateType])

  useEffect(() => {
    if (filterName == 'Length') {
      if (catalogUpdateLength && !isCatalogUpdateLengthSaved && !isCatalogLengthRemoved) {
        setExisitingDropDownValue(catalogUpdateLength)
      } else if (catalogUpdateLength && (isCatalogUpdateLengthSaved || isCatalogLengthRemoved)) {
        const defaultLength = {
          text: "Select Length",
          value: null
        };
        let catalogUpdateLengthTemp = catalogUpdateLength ? JSON.parse(JSON.stringify(catalogUpdateLength)) : []
        catalogUpdateLengthTemp?.unshift(defaultLength);
        let options = catalogUpdateLengthTemp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setLengthList(options)
        dispatch(setCatalogUpdateLengthSave(null))
        dispatch(setCatalogRemoveLength(null))
      }

      if (catalogUpdateLength && isCatalogLengthRemoved && isCatalogLengthRemoved != null) {
        setExisitingDropDownValue(catalogUpdateLength)
        if (!id) {
          let isDeletedValueSelected = catalogUpdateLength?.filter((item?: any) => item?.text == catalogItemValues?.length?.label)
          if (isDeletedValueSelected?.length == 0) {
            setCatalogItemValues((prev: any) => ({
              ...prev,
              length: '',
            }))
          }
        }
      }
    }
  }, [catalogUpdateLength])

  useEffect(() => {
    if (filterName == 'Autonomous') {
      if (catalogUpdateAutonomous && !isCatalogUpdateAutonomousSaved && !isCatalogAutonomousRemoved) {
        setExisitingDropDownValue(catalogUpdateAutonomous)
      } else if (catalogUpdateAutonomous && (isCatalogUpdateAutonomousSaved || isCatalogAutonomousRemoved)) {
        const defaultAutonomous = {
          text: "Select Autonomous",
          value: null
        };
        let catalogUpdateAutonomousTemp = catalogUpdateAutonomous ? JSON.parse(JSON.stringify(catalogUpdateAutonomous)) : []
        catalogUpdateAutonomousTemp?.unshift(defaultAutonomous);
        let options = catalogUpdateAutonomousTemp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setAutonomousList(options)
        dispatch(setCatalogUpdateAutonomousSave(null))
        dispatch(setCatalogRemoveAutonomous(null))
      }

      if (catalogUpdateAutonomous && isCatalogAutonomousRemoved && isCatalogAutonomousRemoved != null) {
        setExisitingDropDownValue(catalogUpdateAutonomous)
        if (!id) {
          let isDeletedValueSelected = catalogUpdateAutonomous?.filter((item?: any) => item?.text == catalogItemValues?.autonomous?.label)
          if (isDeletedValueSelected?.length == 0) {
            setCatalogItemValues((prev: any) => ({
              ...prev,
              autonomous: '',
            }))
          }
        }
      }
    }
  }, [catalogUpdateAutonomous])

  useEffect(() => {
    if (filterName == 'Category') {
      if (catalogUpdateCategory && !isCatalogUpdateCategorySaved && !isCatalogCategoryRemoved) {
        setExisitingDropDownValue(catalogUpdateCategory)
      } else if (catalogUpdateCategory && (isCatalogUpdateCategorySaved || isCatalogCategoryRemoved)) {
        const defaultCategory = {
          text: "Select Category",
          value: null
        };
        let catalogUpdateCategoryTemp = catalogUpdateCategory ? JSON.parse(JSON.stringify(catalogUpdateCategory)) : []
        catalogUpdateCategoryTemp?.unshift(defaultCategory);
        let options = catalogUpdateCategoryTemp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setCategoryList(options)
        dispatch(setCatalogUpdateCategorySave(null))
        dispatch(setCatalogRemoveCategory(null))
      }

      if (catalogUpdateCategory && isCatalogCategoryRemoved && isCatalogCategoryRemoved != null) {
        setExisitingDropDownValue(catalogUpdateCategory)
        if (!id) {
          let isDeletedValueSelected = catalogUpdateCategory?.filter((item?: any) => item?.text == catalogItemValues?.category?.label)
          if (isDeletedValueSelected?.length == 0) {
            setCatalogItemValues((prev: any) => ({
              ...prev,
              category: '',
            }))
          }
        }
      }
    }
  }, [catalogUpdateCategory])

  useEffect(() => {
    if (filterName == 'Category Type') {
      if (catalogUpdateCategoryType && !isCatalogUpdateCategoryTypeSaved && !isCatalogCategoryTypeRemoved) {
        setExisitingDropDownValue(catalogUpdateCategoryType)
      } else if (catalogUpdateCategoryType && (isCatalogUpdateCategoryTypeSaved || isCatalogCategoryTypeRemoved)) {
        const defaultCategoryType = {
          text: "Select CategoryType",
          value: null
        };
        let catalogUpdateCategoryTypeTemp = catalogUpdateCategoryType ? JSON.parse(JSON.stringify(catalogUpdateCategoryType)) : []
        catalogUpdateCategoryTypeTemp?.unshift(defaultCategoryType);
        let options = catalogUpdateCategoryTypeTemp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setCategoryTypeList(options)
        dispatch(setCatalogUpdateCategoryTypeSave(null))
        dispatch(setCatalogRemoveCategoryType(null))
      }

      if (catalogUpdateCategoryType && isCatalogCategoryTypeRemoved && isCatalogCategoryTypeRemoved != null) {
        setExisitingDropDownValue(catalogUpdateCategoryType)
        if (!id) {
          let isDeletedValueSelected = catalogUpdateCategoryType?.filter((item?: any) => item?.text == catalogItemValues?.categoryType?.label)
          if (isDeletedValueSelected?.length == 0) {
            setCatalogItemValues((prev: any) => ({
              ...prev,
              categoryType: '',
            }))
          }
        }
      }
    }
  }, [catalogUpdateCategoryType])

  useEffect(() => {
    if (filterName == 'Category2') {
      if (catalogUpdateCategory2 && !isCatalogUpdateCategory2Saved && !isCatalogCategory2Removed) {
        setExisitingDropDownValue(catalogUpdateCategory2)
      } else if (catalogUpdateCategory2 && (isCatalogUpdateCategory2Saved || isCatalogCategory2Removed)) {
        const defaultCategory2 = {
          text: "Select Category2",
          value: null
        };
        let catalogUpdateCategory2Temp = catalogUpdateCategory2 ? JSON.parse(JSON.stringify(catalogUpdateCategory2)) : []
        catalogUpdateCategory2Temp?.unshift(defaultCategory2);
        let options = catalogUpdateCategory2Temp?.map((val: any) =>
          ({ value: val.value, label: val.text, key: val.value })
        );
        setCategory2List(options)
        dispatch(setCatalogUpdateCategory2Save(null))
        dispatch(setCatalogRemoveCategory2(null))
      }

      if (catalogUpdateCategory2 && isCatalogCategory2Removed && isCatalogCategory2Removed != null) {
        setExisitingDropDownValue(catalogUpdateCategory2)
        if (!id) {
          let isDeletedValueSelected = catalogUpdateCategory2?.filter((item?: any) => item?.text == catalogItemValues?.category2?.label)
          if (isDeletedValueSelected?.length == 0) {
            setCatalogItemValues((prev: any) => ({
              ...prev,
              category2: '',
            }))
          }
        }
      }
    }
  }, [catalogUpdateCategory2])

  useEffect(() => {
    if (catalogUpdateModel && !isCatalogUpdateModelSaved && !isCatalogModelRemoved) {
      setExisitingDropDownValue(catalogUpdateModel)
    } else if (catalogUpdateModel && (isCatalogUpdateModelSaved || isCatalogModelRemoved)) {
      const defaultModel = {
        text: "Select Model",
        value: null
      };
      let catalogUpdateModelTemp = catalogUpdateModel ? JSON.parse(JSON.stringify(catalogUpdateModel)) : []
      catalogUpdateModelTemp?.unshift(defaultModel);
      let options = catalogUpdateModelTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      if (catalogItemValues?.make) {
        setModelsList(options)
      }else{
        setModelsList([])
      }
      dispatch(setCatalogUpdateModelSave(null))
      dispatch(setCatalogRemoveModel(null))
    }

    if (catalogUpdateModel && isCatalogModelRemoved && isCatalogModelRemoved != null) {
      setExisitingDropDownValue(catalogUpdateModel)
      if (!id) {
        let isDeletedValueSelected = catalogUpdateModel?.filter((item?: any) => item?.text == catalogItemValues?.model?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            model: '',
          }))
        }
      }
    }
  }, [catalogUpdateModel])

  useEffect(() => {
    let options: any = []
    if (budgetingPercentOptionsList && !isBudgetingPercentOptionsSaved && !isBudgetingPercentOptionsDeleted) {
      setExisitingDropDownValue(budgetingPercentOptionsList)
    } else if (budgetingPercentOptionsList && (isBudgetingPercentOptionsSaved || isBudgetingPercentOptionsDeleted)) {
      const defaultBudgetPercent = {
        text: "Select Budget Percent",
        value: null
      };
      let budgetingPercentOptionsListTemp = budgetingPercentOptionsList ? JSON.parse(JSON.stringify(budgetingPercentOptionsList)) : []
      budgetingPercentOptionsListTemp?.unshift(defaultBudgetPercent);
      options = budgetingPercentOptionsListTemp?.map((val: any) =>
        ({ value: val.value, label: (val.text + '%'), key: val.value })
      );
      setBudgetPercentList(options)
      dispatch(isBudgetingPercentOptionSaved(null))
      dispatch(isBudgetingPercentOptionDeleted(null))
    }

    if (budgetingPercentOptionsList && isBudgetingPercentOptionsDeleted && isBudgetingPercentOptionsDeleted != null) {
      setExisitingDropDownValue(budgetingPercentOptionsList)
      if (!id) {
        let isDeletedValueSelected = budgetingPercentOptionsList?.filter((item?: any) => item?.text + '%' == catalogItemValues?.budgetingPercent?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({ ...prev, budgetingPercent: (options?.find((i: any) => i.label == "10%") ?? '') }))
        }
      }
    }else if (budgetingPercentOptionsList && isBudgetingPercentOptionsSaved && isBudgetingPercentOptionsSaved != null){
      setCatalogItemValues((prev: any) => ({ ...prev, budgetingPercent: (catalogItemValues?.budgetingPercent ? catalogItemValues?.budgetingPercent : (options?.find((i: any) => i.label == "10%") ?? '')) }))
    }

  }, [budgetingPercentOptionsList])

  useEffect(() => {
    if (usefulLifeOptionsList && !isUsefulLifeOptionsSaved && !isUsefulLifeOptionsDeleted) {
      setExisitingDropDownValue(usefulLifeOptionsList)
    } else if (usefulLifeOptionsList && (isUsefulLifeOptionsSaved || isUsefulLifeOptionsDeleted)) {
      const defaultUseFulLife = {
        text: "Select UseFulLife/LeaseTerms",
        value: null
      };
      let usefulOptionsListTemp = usefulLifeOptionsList ? JSON.parse(JSON.stringify(usefulLifeOptionsList)) : []
      usefulOptionsListTemp?.unshift(defaultUseFulLife);
      let options = usefulOptionsListTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setUseFulLifeList(options)
      dispatch(isUsefulLifeOptionSaved(null))
      dispatch(isUsefulLifeOptionDeleted(null))
    }

    if (usefulLifeOptionsList && isUsefulLifeOptionsDeleted && isUsefulLifeOptionsDeleted != null) {
      setExisitingDropDownValue(usefulLifeOptionsList)
      if (!id) {
        let isDeletedValueSelected = usefulLifeOptionsList?.filter((item?: any) => item?.text == catalogItemValues?.leaseTerm?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            leaseTerm: '',
          }))
        }
      }
    }
  }, [usefulLifeOptionsList])

  useEffect(() => {
    if (tagsOptionsList && !isTagsOptionsSaved && !isTagsOptionsDeleted) {
      setExisitingDropDownValue(tagsOptionsList)
    } else if (tagsOptionsList && (isTagsOptionsSaved || isTagsOptionsDeleted)) {
      const defaultTags = {
        text: "Select Tags",
        value: null
      };
      let tagsOptionsListTemp = tagsOptionsList ? JSON.parse(JSON.stringify(tagsOptionsList)) : []
      tagsOptionsListTemp?.unshift(defaultTags);
      let options = tagsOptionsListTemp?.map((val: any) =>
        ({ value: val.value, label: val.text, key: val.value })
      );
      setUseList(options)
      dispatch(isTagsOptionSaved(null))
      dispatch(isTagsOptionDeleted(null))
    }

    if (tagsOptionsList && isTagsOptionsDeleted && isTagsOptionsDeleted != null) {
      setExisitingDropDownValue(tagsOptionsList)
      if (!id) {
        let isDeletedValueSelected = tagsOptionsList?.filter((item?: any) => item?.text == catalogItemValues?.use?.label)
        if (isDeletedValueSelected?.length == 0) {
          setCatalogItemValues((prev: any) => ({
            ...prev,
            use: '',
          }))
        }
      }
    }
  }, [tagsOptionsList])

  const commonValidationPopup = () => {
    setPopupcontentComplete({
      ...PopupcontentComplete,
      titleImg: ConfirmationBee,
      title: "INFORMATION",
      isDialogVisible: true,
      isTitleWarning: false,
      subtextcontent: 'Please select the vehicle type',
      outlineBtnText: "Close",
      isSingleConfirmationBtn: true,
      popupOutlinebtnOnclickComplete: () => {
        hideDialogComplete()
      }
    });
  }

  const editFilterModel = () => {
    if (catalogItemValues?.vehicleType?.orderRequestSubTypeId || (selectedAssetType?.assetType?.value != CONSTANTS.VEHICLE && selectedAssetType?.assetType?.id)) {
      setShowEditPopup(true)
    } else {
      commonValidationPopup()
    }
  }

  const onPopupFilterModel = (filterName: any) => {
    setExisitingDropDownValue([])
    if (filterName != "Category Type" && filterName != "Category2") {
      if (catalogItemValues?.vehicleType?.orderRequestSubTypeId || (selectedAssetType?.assetType?.value != CONSTANTS.VEHICLE && selectedAssetType?.assetType?.id)) {
        addFilterGetData(filterName, dispatch, catalogItemValues, selectedAssetType)
        if (filterName == "Eq Class Code") {
          setEqClassCodePopup(true)
          setAddEqClassCodeError('')
          setAddEqClassDescriptionError('')
        } else {
          setFilterModelPopup(true);
          setFieldValueError('')
        }

        setFilterName(filterName);
      } else {
        commonValidationPopup()
      }
    } else {
      if (catalogItemValues?.category?.value) {
        if (filterName == "Category Type") {
          dispatch(getCatalogUpdateCategoryType(catalogItemValues?.category?.value, AttributeName.CATEGORY_TYPE))
        } else if (filterName == "Category2") {
          dispatch(getCatalogUpdateCategory2(catalogItemValues?.category?.value, AttributeName.CATEGORY2))
        }
        setFilterModelPopup(true);
        setFieldValueError('')
        setFilterName(filterName);
      } else {
        setPopupcontentComplete({
          ...PopupcontentComplete,
          titleImg: ConfirmationBee,
          title: "INFORMATION",
          isDialogVisible: true,
          isTitleWarning: false,
          subtextcontent: 'Please select the Category',
          outlineBtnText: "Close",
          isSingleConfirmationBtn: true,
          popupOutlinebtnOnclickComplete: () => {
            hideDialogComplete()
          }
        });
      }
    }
  }

  const validateModel = (value?: any) => {
    let isValid = true;
    if (value?.trim()?.length == 0 || value == undefined || value == null) {
      setModelError('Please enter the Model')
      isValid = false
    } else if (value?.length > 60) {
      setModelError(`Model must be less than 60 characters`)
      isValid = false
    } else {
      setModelError('')
    }
    return isValid
  }

  const handleClickModelAdd = () => {
    let isModelValidForSave = validateModel(selectedModel)
    if (selectedMake?.length == 0) {
      setModelMakeError("Please select atleast one make")
    } else {
      setModelMakeError('')
    }
    let makeIds: any = []
    selectedMake?.map((makeVal?: any) => {
      makeIds.push(parseInt(makeVal?.key))
    })
    if (isModelValidForSave && selectedMake?.length) {
      dispatch(getCatalogUpdateModelValidate({
        makeId: makeIds,
        modelName: selectedModel.trim()
      }))
    }
  }

  const handleClickAddModel = (e: any) => {
    e.preventDefault();
    if (catalogItemValues?.vehicleType?.orderRequestSubTypeId || (selectedAssetType?.assetType?.value != CONSTANTS.VEHICLE && selectedAssetType?.assetType?.id)) {
      let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
      let isEquipment = selectedAssetType?.assetType?.value !== CONSTANTS.VEHICLE ? AttributeName.MANUFACTURER : AttributeName.MAKE
      dispatch(getCatalogUpdateMake(subTypeId, isEquipment))
      dispatch(getCatalogUpdateModel(subTypeId, AttributeName.MODEL))
      setShowAddModelModal(true)
      setModelMakeError('')
      setModelError('')
      setSelectedMake([])
      setSelectedModel("")
      setExisitingDropDownValue([])
    } else {
      setPopupcontentComplete({
        ...PopupcontentComplete,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: 'Please select the vehicle type',
        outlineBtnText: "Close",
        isSingleConfirmationBtn: true,
        popupOutlinebtnOnclickComplete: () => {
          hideDialogComplete()
        }
      })
    }
  }

  const validateEqClassValues = (filterName?: any, value?: any) => {
    let isValid = true;
    if (value?.trim()?.length == 0 || value == undefined || value == null) {
      if (filterName == "Code") {
        setAddEqClassCodeError('Please enter Eq Class Code')
      } else {
        setAddEqClassDescriptionError('Please enter Eq Class Description')
      }
      isValid = false
    } else if (value?.length > 60 && filterName != "Code") {
        setAddEqClassDescriptionError(`Eq Class Description must be less than 60 characters`)
      isValid = false
    } else if(value?.length > 20 && filterName == "Code"){
      setAddEqClassCodeError(`Eq Class Code must be less than 20 characters`)
      isValid = false
    } else {
      if (filterName == "Code") {
        setAddEqClassCodeError('')
      } else {
        setAddEqClassDescriptionError("")
      }
    }
    return isValid
  }

  const handleEqClassCodeAdd = () => {
    let isCodeValid = validateEqClassValues("Code", eqClassCode)
    let isDescriptionValid = validateEqClassValues("Description", eqClassDescription)
    if (isCodeValid && isDescriptionValid) {
      let subTypeId = selectedAssetType?.assetType?.value == CONSTANTS.VEHICLE ? catalogItemValues?.vehicleType?.orderRequestSubTypeId : selectedAssetType?.assetType?.id
      dispatch(getCatalogUpdateEqClassCodeValidate({
        subTypeId: parseInt(subTypeId),
        eqclasscode: eqClassCode.trim()
      }))
    }
  }

  return (
    <CreateAsset
      breadcrumlist={breadcrumlist}
      handleClickBack={handleClickBack}
      assetTypeOption={assetTypeOption}
      onClickAddItemBtn={onClickAddItemBtn}
      onChangeAssetType={onChangeAssetType}
      addItemClicked={addItemClicked}
      handleClickCancel={handleClickCancel}
      PopupcontentComplete={PopupcontentComplete}
      hideDialogComplete={hideDialogComplete}
      handleClickAdd={handleClickAdd}
      handleOnChangeKitToggle={handleOnChangeKitToggle}
      showKitAttributeTable={showKitAttributeTable}
      list={list}
      setList={setList}
      error={error}
      setError={setError}
      selectedAssetType={selectedAssetType}
      handleNAPChange={handleNAPChange}
      catalogItemValues={catalogItemValues}
      setCatalogItemValues={setCatalogItemValues}
      statusOptions={statusOptions}
      vehicleTypeList={vehicleTypeList}
      capacityList={capacityList}
      noOfDoorsList={noOfDoorsList}
      makeList={makeList}
      modelsList={modelsList}
      upfitOptionList={upfitOptionList}
      driveTrainList={driveTrainList}
      snowSetupList={snowSetupList}
      powerTypeList={powerTypeList}
      eqClassCodeList={eqClassCodeList}
      vehicleLevelList={vehicleLevelList}
      yearList={yearList}
      categoryList={categoryList}
      deckSizeList={deckSizeList}
      deckTypeList={deckTypeList}
      stateAvailabilityList={stateAvailabilityList}
      programStatusList={programStatusList}
      annualHoursList={annualHoursList}
      autonomousList={autonomousList}
      sizeList={sizeList}
      lengthList={lengthList}
      budgetPercentList={budgetPercentList}
      useFulLifeList={useFulLifeList}
      onChangeStatus={onChangeStatus}
      setCatalogItemErrors={setCatalogItemErrors}
      catalogItemErrors={catalogItemErrors}
      validateCatalogItemValues={validateCatalogItemValues}
      onUploadClick={onUploadClick}
      attachmentsList={attachmentsList}
      onRemoveAttachment={onRemoveAttachment}
      vehicleTypeDropdown={vehicleTypeDropdown}
      id={id}
      catalogItemByAssetModelId={catalogItemByAssetModelId}
      setKitAttributeValues={setKitAttributeValues}
      kitAttributeValues={kitAttributeValues}
      getTotalKitPrice={getTotalKitPrice}
      validateAddedKitValues={validateAddedKitValues}
      getGLCode={getGLCode}
      getRequestTypeForEditScreen={getRequestTypeForEditScreen}
      seatingCapacityList={seatingCapacityList}
      enclosedCabList={enclosedCabList}
      classTypeList={classTypeList}
      groupTypeList={groupTypeList}
      cdlList={cdlList}
      grossWeightList={grossWeightList}
      vehicleClassList={vehicleClassList}
      useList={useList}
      trimList={trimList}
      category2List={category2List}
      categoryTypeList={categoryTypeList}
      constructionEquipmentWithSubCategory={CONSTRUCTION_EQUIPMENT_CATEGORY_WITH_CATEGORY_2}
      standardizedEquipmentWithSubCategory={STANDARDIZED_EQUIPMENT_CATEGORY_WITH_CATEGORY_2}
      snowWithSubCategory={SNOW_CATEGORY_WITH_CATGORY_TYPE}

      filterName={filterName}
      setFilterName={setFilterName}
      filterModelPopup={filterModelPopup}
      showEditPopup = {showEditPopup}
      onPopupFilterModel={onPopupFilterModel}
      setFilterModelPopup={setFilterModelPopup}
      ExistingDropDownValue={ExistingDropDownValue}
      handleClickModelAdd={handleClickModelAdd}
      handleClickAddModel={handleClickAddModel}
      setSelectedModel={setSelectedModel}
      selectedModel={selectedModel}
      setSelectedMake={setSelectedMake}
      selectedMake={selectedMake}
      showAddModelModal={showAddModelModal}
      setShowAddModelModal={setShowAddModelModal}
      filterEqClassCodePopup={filterEqClassCodePopup}
      setEqClassCodePopup={setEqClassCodePopup}
      handleEqClassCodeAdd={handleEqClassCodeAdd}
      setEqClassCode={setEqClassCode}
      eqClassCode={eqClassCode}
      setEqClassDescription={setEqClassDescription}
      eqClassDescription={eqClassDescription}
      setAddEqClassCodeError={setAddEqClassCodeError}
      addEqClassCodeError={addEqClassCodeError}
      setAddEqClassDescriptionError={setAddEqClassDescriptionError}
      addEqClassDescriptionError={addEqClassDescriptionError}
      modelError={modelError}
      setModelError={setModelError}
      validateEqClassValues={validateEqClassValues}
      setFieldValueError={setFieldValueError}
      fieldValueError={fieldValueError}
      validateModel={validateModel}
      setModelMakeError={setModelMakeError}
      modelMakeError={modelMakeError}
      typeList={typeList}
      editFilterModel = {editFilterModel}
      setShowEditPopup = {setShowEditPopup}
      actionType = {actionType}
    />
  )
}

export default CreateAssetContainer;